/*
  biobio-trio.js: comportamento da LP do Trio Essencial.
  Plano: docs/plans/2026-08-11-lp-trio-essencial.md.

  Carregado UMA vez pela section do heroi. Guard de execucao unica no topo
  (mesmo padrao de assets/biobio-lp.js): o Shopify nao dedupa tag <script>.

  Peca 1 (Tarefa 2) - PORTAL DA CASCA DO DRAWER PRO <body>.
  O tema poe `overflow-x: hidden` no <body> (assets/styles.css.liquid:1154), o
  que quebra `position: fixed`/`sticky` em qualquer ancestral que nao seja filho
  direto do <body> real; no iOS, `fixed` dentro de container de scroll e tratado
  como estatico. Precedente documentado em HANDOFF-bundle-selector-fastbundle.md
  e em assets/biobio-kit-meter.js. Por isso a casca do drawer E a barra fixa sao
  adotadas pro <body> na carga da pagina.

  Peca 2 (Tarefa 3) - GATILHO DE QUICK-SHOP.
  Qualquer elemento [data-trio-quickshop-trigger] (cards do kit e CTAs dos
  capitulos) e um <a href> real pra PDP do componente, funcional sem JS. Com JS,
  o clique vira o evento `trio:drawer-open` com `mode: 'quickshop'`. A view
  quickshop e populada pelo fragmento buscado em /products/<handle>?view=quick-shop
  (Tarefa 8; ver openQuickShop/loadQuickShop abaixo).

  ATENCAO (Fix round 1 da Tarefa 8): a INTERCEPTACAO do clique (preventDefault +
  dispatch de trio:drawer-open) NAO mora neste arquivo. Este script carrega com
  `defer`, que so executa apos o documento inteiro terminar de parsear; o <a
  href> do gatilho fica clicavel muito antes disso, e um clique nessa janela
  navegava a pagina de verdade pro PDP (comprovado: 64% de falha em 25 execucoes
  isoladas, main-frame Page.frameNavigated pra URL exata do gatilho). A
  interceptacao mora num <script> SEM defer no topo de
  sections/biobio-trio-hero.liquid. Este arquivo so CONSOME o `trio:drawer-open`
  ja despachado por aquele script.

  Peca 3 (Tarefa 7) - SELECTOR UNICO, DRAWER DE COMPRA E BARRA FIXA.
  Existe UM unico <bundle-selector> na pagina, renderizado inline por
  sections/biobio-trio-compra.liquid. Quando a barra fixa abre o drawer, esse
  MESMO no e adotado pra dentro da view de compra por portal (Map<Element,
  Comment>, estado local a esta IIFE, sem nada em window) e devolvido ao marker
  quando o drawer fecha. Nao existe segundo seletor, espelho de radios nem
  estado duplicado: por isso a selecao nao pode dessincronizar.

  O que torna isso seguro: assets/biobio-bundle-selector.js ganhou nesta mesma
  tarefa um connectedCallback idempotente e um abort adiado por microtask, senao
  cada movimento do no religaria listeners (adicionando duas linhas iguais ao
  carrinho) e apagaria a selecao da cliente.

  Regra dura da barra: ela SEMPRE abre o drawer, tanto com selecao incompleta
  quanto completa. Nunca aciona o botao de adicionar por baixo dos panos nem
  apenas rola ate o bloco inline. Adicionar ao carrinho continua sendo exclusivo
  do CTA de dentro do seletor.

  Peca 4 (Tarefa 9) - FINDER RESIDENTE E APLICACAO EXPLICITA.
  A view `finder` (snippets/biobio-quick-shop.liquid) NAO faz fetch: ja vem
  populada em Liquid com biobio-tone-finder-core (modo: 'aplicar'), a Base
  resolvida como 1o item de bundle.components. Abrir o finder e so trocar de
  view (openFinder); nao navega pra /pages/encontre-seu-tom em NENHUM
  momento, mesmo o gatilho do heroi sendo um <a href> real pra la (mesma
  guarda inline sem defer do gatilho de quick-shop, ver
  sections/biobio-trio-hero.liquid).

  O finder so aplica um tom quando a cliente ESCOLHE: tone-finder:applied e
  um evento NOVO e opt-in (assets/biobio-tone-finder.js), disparado so no
  clique em "Usar este tom". tone-finder:resolved (automatico, dispara a
  cada calculo do finder) nunca aplica nada sozinho. Aplicar = clicar o
  MESMO label.swatch[data-variant-id] do <bundle-selector> unico (nunca um
  segundo estado): mesmo caminho de um clique real da cliente.

  Pilha local (viewStack): so quando o drawer ja esta aberto em outro modo
  (o "Nao sabe seu tom?" de dentro do quick-shop da Base) a view anterior
  entra na pilha, pro botao Voltar restaurar exatamente o que a cliente
  estava olhando. Abrir o finder direto do heroi (drawer fechado) nao
  empilha nada -- nao ha view "anterior" nesse caso.

  Peca 5 (Tarefa 10) - TRILHO DE VIDEOS.
  sections/biobio-trio-videos.liquid renderiza ate 8 cards <figure
  class="trio-videos__item"> em HTML estatico (a cascata de fonte inteira e
  resolvida em Liquid no servidor; nao ha fragmento buscado depois pro
  trilho, diferente do quick-shop). Por isso initVideoTrilho() roda no MESMO
  boot sincrono de initEventos()/garantirDrawer() no fim deste arquivo, sem
  esperar DOMContentLoaded: este script carrega com defer, que so executa
  depois que o documento INTEIRO ja parseou (mesmo raciocinio documentado no
  Fix round 1 da Tarefa 8), entao o markup do trilho ja esta no DOM na
  primeira linha que roda aqui.

  Comportamento (lazy por IntersectionObserver, autoplay MUDO, som exclusivo,
  toque pausa/retoma, setas, prefers-reduced-motion) e PORTADO de
  assets/biobio-lp.js, decisao de engenharia ja fechada (spec
  docs/specs/2026-08-11-lp-trio-essencial-design.md secao 8.4): importar
  biobio-lp.js traria biobio-lp.css junto, o mundo visual das LPs legadas do
  qual esta pagina se afasta de proposito.

  Nenhum elemento novo do trilho precisa da guarda inline sem defer da
  Tarefa 8 (ver comentario no topo de sections/biobio-trio-videos.liquid):
  o chip do fallback reusa data-trio-quickshop-trigger (ja coberto); o chip
  do trio e um <a href="#comprar"> real (ancora same-page, nunca navegacao
  de verdade); botao de som e setas sao <button> sem acao nativa nenhuma.

  PDP v2, Tarefa 9: o mesmo comportamento vale para os blocos de "video +
  texto" (sections/biobio-trio-bloco.liquid), GENERALIZADO POR ATRIBUTO em vez
  da classe do trilho. Contrato, que qualquer section pode usar:
  video[data-trio-lazy-video][data-src] dentro de [data-trio-video-frame],
  com [data-trio-sound] (som exclusivo) e [data-trio-play] (toggle
  "Assistir ao trecho": aria-pressed true enquanto toca, rotulo fixo)
  opcionais no mesmo quadro. O video pode levar tambem data-src-hls (master
  HLS), usado no lugar do data-src no layout de celular quando o navegador
  toca HLS nativo, com volta unica ao MP4 se falhar (fix rounds 2 e 3 da T9,
  ver fonteDoVideo). O som e exclusivo entre TODOS os videos desse
  contrato (blocos e trilho), inclusive quando alguem desmuta pelos controles
  nativos (reduced motion) ou pelo lightbox da galeria: ver o listener de
  volumechange. Os players ja observados ficam marcados, entao chamar
  initVideoTrilho() de novo (boot tardio, shopify:section:load do editor) so
  observa os videos novos.

  Peca 6 (Tarefa 11) - FILA DE CLIQUES PENDENTES, fecha a "janela de clique
  morto". O paragrafo da Peca 2 acima ja avisava que um clique antes deste
  arquivo carregar despachava trio:drawer-open pro vazio (0/20 de sucesso
  medido nesta tarefa, clique ~130ms depois do gatilho aparecer). Mesmo
  padrao nos controles do trilho (som, setas), sem NENHUMA acao nativa. A
  guarda inline de sections/biobio-trio-hero.liquid agora enfileira esses
  cliques em window.__biobioTrioQueue em vez de descartar, e da um sinal
  visual imediato (classe is-trio-pending). flushFilaPendente(), chamada
  logo apos initEventos() no boot abaixo, repete cada clique enfileirado
  assim que os listeners de verdade existem -- o toque acaba completando a
  acao, so um pouco depois, nunca fica morto.

  Peca 7 (Tarefa 11.1, I1 da revisao final) - UM MODAL POR VEZ. O lightbox
  do video da galeria e o drawer sao modais e nunca ficam abertos juntos: a
  fila inline trata os dois como um slot so (vale o ultimo toque), abrir um
  fecha o outro (openDrawer -> fecharLightbox, abrirLightbox -> closeDrawer),
  applyInert pula um <dialog> aberto e o fechamento do lightbox nao solta a
  trava de rolagem nem puxa o foco se o drawer estiver aberto.

  Peca 8 (Tarefa 13, v2.1, decisoes do Breno de 25/09 depois do teste no iPhone
  real). (1) Depois de um add bem-sucedido do seletor, a barra (e o botao do
  heroi no desktop) diz "Ver carrinho" e abre o carrinho do tema; trocar um tom
  volta a compra (observarAdd, abrirCarrinhoDoTema). (2) O toque no video dos
  blocos e dos cartoes abre o lightbox da galeria com aquele video, com som, do
  ponto em que estava; o lightbox tem os controles numa faixa acima do video
  (abrirLightbox, fonteDoLightbox). O toque que pausava e retomava o video na
  pagina saiu (a Peca 5 acima descreve a origem dele); pausar e o botao de play.
  (5) A janela do produto busca a view que o drawer declara
  (data-trio-qs-view): nesta PDP, sem preco e sem adicionar, com "Escolher meus
  tons" levando ao seletor do trio.

  Peca 9 (Tarefa 18, 28/09, depois do teste do Breno no iPhone: a janela ficava
  em "Carregando produto..." o tempo de uma ida e volta de rede). Na view sem
  compra desta PDP (quick-shop-vitrine) a janela abre do que ja esta em memoria:
  depois do load, em idle, a pagina busca UMA vez o fragmento de cada produto
  com gatilho, um de cada vez (agendarPreBuscaJanelas; nada em segundo plano com
  economia de dados), e o pointerdown/touchstart do gatilho ja comeca a busca
  antes do click (preBuscarNoToque). O cache guarda a promessa do texto por view
  + handle (pedirFragmentoQs); falha nao fica nele. A view com compra, fora
  desta pagina, busca como sempre. Rodada de correcao 1 (28/09, o Po ainda
  esperava no 3G, ultimo da serie): a serie vai do gatilho mais perto da tela
  ao mais longe e um IntersectionObserver adianta o que se aproxima, aquecendo
  tambem a primeira foto da janela desse produto; o toque num produto sem cache
  aborta a pre-busca de outro (que volta para a fila); o pedido de segundo
  plano leva o header X-Trio-Pre-Busca; trocar de view ou fechar limpa o status.
*/
(function () {
  if (window.__biobioTrioInit) return;
  window.__biobioTrioInit = true;

  /* ================================================================ */
  /* Portal (Map<Element, Comment>), local a esta IIFE                  */
  /* ================================================================ */

  var placeholders = new Map();

  function take(node, target) {
    if (!node || placeholders.has(node)) return;
    var marker = document.createComment('biobio-trio-portal');
    node.before(marker);
    placeholders.set(node, marker);
    target.append(node);
  }

  function give(node) {
    var marker = placeholders.get(node);
    if (!marker) return;
    placeholders.delete(node);

    if (marker.isConnected) {
      marker.replaceWith(node);
      return;
    }

    // O host foi re-renderizado enquanto o no estava emprestado (gatilho real:
    // `shopify:section:load` do Theme Editor) e levou o marcador junto. Sem esta
    // guarda o `replaceWith` seria no-op silencioso e o seletor ficaria preso na
    // view escondida: o bloco de compra da pagina ficaria VAZIO ate recarregar.
    var host = document.querySelector('[data-trio-selector-host]');
    if (!host) return;
    if (host.querySelector('bundle-selector')) {
      // O re-render ja trouxe um seletor novo do servidor; o emprestado virou
      // obsoleto. Devolver os dois deixaria a pagina com DOIS seletores.
      node.remove();
    } else {
      host.appendChild(node);
    }
  }

  /* ================================================================ */
  /* Drawer: refs, modos e estado                                      */
  /* ================================================================ */

  // Um modo por view da casca (snippets/biobio-quick-shop.liquid). `bundle` e
  // `finder` sao estaticos; `quickshop` (Tarefa 8) e montado dinamicamente por
  // openQuickShop (numeral/formato/FPS vem do gatilho, titulo vem do produto
  // so depois do fetch), por isso nao entra aqui. Os textos abaixo sao o
  // fallback do Trio Essencial: garantirDrawer() troca a sobrancelha e o titulo
  // de compra pelos data-trio-eyebrow/data-trio-titulo-compra da casca, que
  // cada pagina preenche pelo seu template.
  var MODES = {
    bundle: {
      eyebrow: 'Trio Essencial BioBio',
      title: 'Comprar o trio',
    },
    finder: {
      eyebrow: 'Trio Essencial BioBio',
      title: 'Encontre seu tom',
    },
  };

  var FOCUSABLE =
    'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),summary,[tabindex]:not([tabindex="-1"])';
  var SKIP_INERT = { SCRIPT: 1, STYLE: 1, LINK: 1, NOSCRIPT: 1, TEMPLATE: 1 };

  var drawer = null;
  var panel = null;
  var titleEl = null;
  var eyebrowEl = null;
  var statusEl = null;
  var backEl = null;
  var views = {};
  var bar = null;

  var openMode = null;
  var currentCfg = null;
  var noEmprestado = null;
  var lastTrigger = null;
  var inertSnapshot = [];
  var savedScrollY = 0;

  // Tarefa 13 (item 1, decisao do Breno de 25/09): id da variante do trio que acabou de entrar no
  // carrinho. Enquanto a selecao for essa, a barra diz "Ver carrinho" e abre o carrinho do tema; a
  // primeira troca de tom zera (so um add novo traz o estado de volta). Ver observarAdd.
  var varianteAdicionada = null;
  // Conta os adds bem-sucedidos (C3): a leitura do /cart.js que comecou antes de um add, mesmo da mesma
  // variante, chega velha e nao pode desfazer o estado que esse add trouxe.
  var geracaoDoAdd = 0;
  var ROTULO_VER_CARRINHO = 'Ver carrinho';

  // Pilha local do drawer (Tarefa 9): guarda { mode, cfg } de views
  // ABANDONADAS por uma navegacao interna (hoje so o gatilho "Nao sabe seu
  // tom?" do quick-shop da Base, que muda pra `finder` sem fechar o drawer).
  // Aberturas de fora do drawer (bar fixa, gatilho de quick-shop, link do
  // heroi) NUNCA empilham -- sao entradas "frescas", nao um desvio
  // reversivel. `goBack()` desempilha e reabre exatamente esse modo/cabecalho
  // reaproveitando openDrawer, sem duplicar a logica de release/adopt.
  var viewStack = [];

  // Quick-shop (Tarefa 8): token de sequencia + AbortController do fetch em
  // curso. Abrir um segundo produto antes da resposta do primeiro volta
  // aborta/ignora a resposta velha (guard por `seq`, nao so pelo abort: o
  // abort pode nao interromper a leitura do body a tempo).
  var qsSeq = 0;
  var qsAbort = null;

  // Tarefa 18: cache dos fragmentos da janela, so na view sem compra desta PDP (VIEW_VITRINE). Chave
  // view + handle; valor { promessa, quando, renovando }, em que a promessa e a do texto HTML ja
  // conferido (status, content-type e contrato). Vale enquanto a pagina estiver aberta: a janela desta
  // pagina nao mostra preco, e estoque e tons mudam pouco numa visita. Com mais de QS_VALIDADE_MS, a
  // abertura usa o que tem e renova em segundo plano para a seguinte. Ver pedirFragmentoQs.
  var VIEW_VITRINE = 'quick-shop-vitrine';
  var QS_VALIDADE_MS = 10 * 60 * 1000;
  var qsCache = new Map();
  var preBuscaAgendada = false;
  // Rodada de correcao 1: handle da janela que esta esperando o fragmento (a pre-busca em voo dele nunca
  // cede ao toque; ver cederAoToque).
  var qsCarregando = null;

  // O seletor que vale e o do bloco de compra. Depois de um re-render da section
  // com o drawer aberto (Theme Editor) o documento tem dois por um instante: o
  // novo, no host, e o emprestado, dentro da view. Por isso a busca prioriza o
  // host e so cai no genérico quando o host esta vazio (que e justamente o
  // estado em que o no esta emprestado).
  function selectorNode() {
    return (
      document.querySelector('[data-trio-selector-host] bundle-selector') ||
      document.querySelector('bundle-selector')
    );
  }

  function selectorHost() {
    return document.querySelector('[data-trio-selector-host]');
  }

  // PDP v2 da Base (Task 4, 21/10/2026): os swatches de tom em que o finder da gaveta aplica e pelos
  // quais restringirFinderAoKit filtra as faixas. Com <bundle-selector> (Trio Essencial, Trio Make Glow,
  // Kit Glow), os label.swatch[data-variant-id] dele, como sempre. Na falta dele, os do <pdp-offer>
  // (snippets/biobio-pdp-offer.liquid): no modo direto (1 degrau, sem radio pdp-tier) a fileira
  // .pdp-offer__swatches; no modo cards, a 1a .pdp-offer__unit do degrau marcado, o mesmo escopo do
  // onToneResolved de assets/biobio-pdp-offer.js. Sem os dois, ou sem degrau marcado, lista vazia.
  function swatchesDeTom() {
    var SWATCH = 'label.swatch[data-variant-id]';
    var seletor = selectorNode();
    if (seletor) return Array.prototype.slice.call(seletor.querySelectorAll(SWATCH));
    var oferta = document.querySelector('pdp-offer');
    if (!oferta) return [];
    var escopo = null;
    if (oferta.querySelector('input[name="pdp-tier"]')) {
      var marcado = oferta.querySelector('input[name="pdp-tier"]:checked');
      var degrau = marcado ? marcado.closest('.pdp-offer__tier') : null;
      escopo = degrau ? degrau.querySelector('.pdp-offer__unit') : null;
    } else {
      escopo = oferta.querySelector('.pdp-offer__swatches');
    }
    return escopo ? Array.prototype.slice.call(escopo.querySelectorAll(SWATCH)) : [];
  }

  /* ================================================================ */
  /* Trava de scroll (portada de assets/biobio-kit-meter.js)           */
  /* ================================================================ */

  // Classe na RAIZ (html + body), sem position: fixed e sem aritmetica de
  // scroll: `overflow: hidden` preserva a posicao e os sticky por construcao, e
  // classe (em vez de style inline) sobrevive ao assets/predictive-search.js,
  // que zera body.style.* a cada clique fora da busca. No iOS quem segura o
  // toque e o touchGuard, nao o CSS. As duas tentativas anteriores que
  // fracassaram estao documentadas em assets/biobio-kit-meter.css.
  function touchGuard(event) {
    if (!openMode || !panel) return;
    if (!panel.contains(event.target)) event.preventDefault();
  }

  function lockScroll() {
    savedScrollY = window.scrollY || window.pageYOffset || 0;
    document.documentElement.classList.add('biobio-trio-noscroll');
    document.body.classList.add('biobio-trio-noscroll');
    document.addEventListener('touchmove', touchGuard, { passive: false });
  }

  function unlockScroll() {
    document.documentElement.classList.remove('biobio-trio-noscroll');
    document.body.classList.remove('biobio-trio-noscroll');
    document.removeEventListener('touchmove', touchGuard, { passive: false });
    // overflow: hidden preserva a posicao sozinho; isto e so rede de seguranca.
    if (Math.abs((window.scrollY || 0) - savedScrollY) > 1) window.scrollTo(0, savedScrollY);
  }

  /* ================================================================ */
  /* inert nos irmaos do drawer, com restauracao do estado anterior     */
  /* ================================================================ */

  function applyInert() {
    inertSnapshot = [];
    var kids = Array.prototype.slice.call(document.body.children);
    for (var i = 0; i < kids.length; i++) {
      var el = kids[i];
      if (el === drawer || SKIP_INERT[el.tagName]) continue;
      // Tarefa 11.1 (I1 da revisao final): um <dialog> aberto nunca vira inert. O lightbox aberto
      // e fechado por openDrawer antes de chegar aqui; se um dia um dialog aberto sobrar, inert por
      // cima dele deixaria na tela um modal que nao fecha no toque.
      if (el.tagName === 'DIALOG' && el.open) continue;
      inertSnapshot.push({ el: el, had: el.hasAttribute('inert') });
      el.setAttribute('inert', '');
    }
  }

  function releaseInert() {
    for (var i = 0; i < inertSnapshot.length; i++) {
      if (!inertSnapshot[i].had) inertSnapshot[i].el.removeAttribute('inert');
    }
    inertSnapshot = [];
  }

  /* ================================================================ */
  /* Abrir, trocar de modo e fechar                                     */
  /* ================================================================ */

  function setHeading(cfg) {
    var labelled = [];
    if (eyebrowEl) {
      if (cfg.eyebrow) {
        eyebrowEl.textContent = cfg.eyebrow;
        eyebrowEl.hidden = false;
        labelled.push(eyebrowEl.id);
      } else {
        eyebrowEl.textContent = '';
        eyebrowEl.hidden = true;
      }
    }
    if (titleEl) {
      titleEl.textContent = cfg.title;
      labelled.push(titleEl.id);
    }
    // aria-labelledby dinamico: acompanha o modo e so aponta pro que esta na tela.
    if (panel && labelled.length) panel.setAttribute('aria-labelledby', labelled.join(' '));
  }

  function showView(mode) {
    Object.keys(views).forEach(function (key) {
      views[key].hidden = key !== mode;
    });
  }

  // Congela a altura do host enquanto o seletor esta no drawer, pra pagina de
  // tras nao sanfonar (e o conteudo voltar exatamente pro mesmo lugar).
  function reserveHostSpace(node) {
    var host = selectorHost();
    if (!host || !node) return;
    var h = node.offsetHeight;
    if (h > 0) host.style.minHeight = h + 'px';
  }

  function releaseHostSpace() {
    var host = selectorHost();
    if (host) host.style.removeProperty('min-height');
  }

  function adoptSelector() {
    var node = selectorNode();
    var view = views.bundle;
    if (!node || !view) return;
    if (node.parentElement === view) return;
    reserveHostSpace(node);
    take(node, view);
    noEmprestado = node;
  }

  // DEVOLVE o no antes de qualquer limpeza de view. Trocar a ordem apagaria o
  // unico seletor da pagina.
  //
  // Devolve o no EMPRESTADO (guardado em `noEmprestado`), nunca o que um
  // querySelector achar na hora: se a section for re-renderizada com o drawer
  // aberto, o seletor novo do servidor aparece ANTES no documento e devolver o
  // errado deixaria o emprestado preso dentro da view escondida.
  function releaseView(mode) {
    if (mode === 'bundle') {
      if (noEmprestado) {
        give(noEmprestado);
        noEmprestado = null;
      }
      releaseHostSpace();
    }
    if (mode === 'quickshop') {
      // Aborta o fetch em curso (se houver): trocar de modo com uma resposta
      // ainda a caminho nao pode injetar o produto errado quando ela chegar.
      // Na view sem compra (Tarefa 18) o abort so encerra a espera desta
      // abertura; o pedido do cache segue e serve a proxima (esperarOuAbortar).
      if (qsAbort) {
        qsAbort.abort();
        qsAbort = null;
      }
    }
  }

  function openDrawer(mode, options) {
    options = options || {};
    // `quickshop` (Tarefa 8) nao tem entrada estatica em MODES: o cabecalho
    // varia por produto (numeral/formato/FPS do gatilho, titulo so depois do
    // fetch), entao quem abre passa `options.cfg` explicito.
    var cfg = options.cfg || MODES[mode];
    // Resolve a casca aqui, no momento do clique: o clique pode chegar antes do
    // DOMContentLoaded, quando este script ja executou mas o boot tardio ainda
    // nao rodou.
    garantirDrawer();
    if (!drawer || !panel || !cfg) return false;

    // Um modal por vez (Tarefa 11.1, I1 da revisao final): abrir o drawer fecha o lightbox do video.
    // close() e sincrono (o `open` cai na hora); o evento `close` chega depois e ve o drawer aberto,
    // entao nao tira a trava nem devolve o foco (ver garantirLightbox). Quem abriu o lightbox vira o
    // ponto de retorno do foco quando o drawer fechar (o foco agora esta dentro do dialog fechado).
    var gatilhoDoLightbox = lightbox && lightbox.open ? lightboxGatilho : null;
    fecharLightbox();

    if (openMode && openMode !== mode) {
      releaseView(openMode);
      // Tarefa 18, rodada de correcao 1 (bug antigo, aprovado): a linha de status e da view que sai. Sem isto,
      // "Carregando produto..." de uma janela abandonada ficava por cima da compra ou do finder. Quem precisa
      // de status na view nova (Tom aplicado, Carregando... do finder) poe depois do openDrawer.
      setStatus('');
    }
    if (!openMode) lastTrigger = options.trigger || gatilhoDoLightbox || document.activeElement;

    if (mode === 'bundle') adoptSelector();

    setHeading(cfg);
    showView(mode);
    drawer.hidden = false;
    // .trio-drawer__body e o unico rolavel (Tarefa 5); o painel em si nao
    // rola mais (overflow: hidden), entao panel.scrollTop sempre seria 0 e
    // nunca resetava a posicao real da rolagem anterior.
    var corpo = drawer.querySelector('.trio-drawer__body');
    if (corpo) corpo.scrollTop = 0;
    // Foco IMEDIATO no painel, antes de qualquer rede (as views das Tarefas 8 e
    // 9 buscam conteudo; o dialogo ja tem que estar utilizavel nesse meio tempo).
    panel.focus();

    if (!openMode) {
      // Tarefa 11.1 (minor 4 da revisao final): como o lightbox, o drawer silencia o video que
      // estiver tocando com som (segue tocando mudo; o botao de som acompanha).
      silenciarVideos();
      lockScroll();
      applyInert();
    }
    openMode = mode;
    currentCfg = cfg;
    updateBackButton();
    return true;
  }

  // Desempilha a view anterior (se houver) e reabre exatamente ela via
  // openDrawer -- reusa release/adopt/setHeading/showView/foco tal qual um
  // "switch de modo" comum, sem logica duplicada. `openMode` continua truthy
  // durante a chamada, entao openDrawer nem mexe em lastTrigger/lockScroll de
  // novo (so acontece na primeira abertura da sessao).
  function goBack() {
    if (!viewStack.length) return;
    var prev = viewStack.pop();
    openDrawer(prev.mode, { cfg: prev.cfg });
  }

  function updateBackButton() {
    if (backEl) backEl.hidden = viewStack.length === 0;
  }

  function closeDrawer(options) {
    if (!openMode || !drawer) return;
    releaseView(openMode);
    // Tarefa 18, rodada de correcao 1: fechar limpa a linha de status (ver openDrawer).
    setStatus('');
    openMode = null;
    currentCfg = null;
    viewStack = [];
    updateBackButton();
    showView(null);
    drawer.hidden = true;
    unlockScroll();
    releaseInert();

    var restore = !options || options.restoreFocus !== false;
    // Aberto pelo "Me ajuda a escolher" da barra de tom da Base: o foco volta a barra, mesmo que o
    // gatilho (link da gaveta de tom) ja tenha saido da pagina.
    var voltouABarra = restore && origemBarraDe(lastTrigger) && pedirFocoABarra();
    if (restore && !voltouABarra && lastTrigger && document.contains(lastTrigger) && typeof lastTrigger.focus === 'function') {
      lastTrigger.focus();
    }
    lastTrigger = null;
  }

  // Gatilho que carrega data-pdp-tom-origem (so a barra de tom da Base poe): o finder devolve o foco a
  // barra em vez de ao gatilho. Qualquer outro gatilho segue o caminho de sempre.
  function origemBarraDe(gatilho) {
    return !!(gatilho && typeof gatilho.hasAttribute === 'function' && gatilho.hasAttribute('data-pdp-tom-origem'));
  }

  // Com origem na barra, quem devolve o foco é a própria barra: o pedido sai num evento cancelável no document e a
  // barra de tom (PdpCta em assets/biobio-pdp-v2.js) atende assentando antes o redesenho que o clique no label
  // agendou (ele recria o "Trocar o tom" por innerHTML, e um foco dado agora se perderia). Atendido (cancelado),
  // nada mais a fazer; sem quem atenda, o foco direto de antes. Devolve true quando o foco teve para onde ir.
  function pedirFocoABarra() {
    var pedido = new CustomEvent('pdp-tom:devolver-foco', { cancelable: true });
    if (!document.dispatchEvent(pedido)) return true;
    return devolverFocoABarra();
  }

  // Foco na barra sem rolar a pagina. Barra escondida (offsetParent nulo): reserva no .product-details,
  // com tabindex -1 so enquanto dura o foco. Devolve false se nao havia onde focar.
  function devolverFocoABarra() {
    var alvo = document.querySelector('[data-pdp-tom-foco]');
    if (alvo && alvo.offsetParent !== null && typeof alvo.focus === 'function') {
      alvo.focus({ preventScroll: true });
      return true;
    }
    var reserva = document.querySelector('.product-details');
    if (!reserva || typeof reserva.focus !== 'function') return false;
    // So poe tabindex quando a reserva nao tem o seu; o que e dela nunca se apaga.
    var poseiTabindex = !reserva.hasAttribute('tabindex');
    var tirarTabindex = function () {
      if (poseiTabindex) reserva.removeAttribute('tabindex');
      poseiTabindex = false;
    };
    if (poseiTabindex) {
      reserva.setAttribute('tabindex', '-1');
      reserva.addEventListener('blur', function aoPerderFoco() {
        tirarTabindex();
        reserva.removeEventListener('blur', aoPerderFoco);
      });
    }
    reserva.focus({ preventScroll: true });
    // Foco nao pegou (ancestral inert, elemento sem caixa): o blur nunca viria, limpa na hora.
    if (document.activeElement !== reserva) tirarTabindex();
    return true;
  }

  /* ================================================================ */
  /* Espelho do seletor: pontos, tons, preco e filetes dos capitulos    */
  /* ================================================================ */

  // `bundle:variant-changed` e NOTIFICACAO: o detail so traz selectedByComponent
  // (sem variante nem preco). O estado real se le do proprio elemento que
  // emitiu, ja depois de resolveBundleVariant(): swatch selecionado de cada
  // card, [data-pill-name], [data-bundle-total], [data-bundle-compare],
  // [data-bundle-variant-id] e o estado do botao de adicionar.
  //
  // Kit com slots (Combo Renata Meins, spec 2026-10-26, 6.2): as duas Bases tem o mesmo id de produto, entao com
  // data-bundle-slots no seletor a chave de porProduto e a posicao do card (data-slot-index, a mesma dos pontos da
  // barra), e primeiroDoProduto guarda o primeiro card de cada produto para os filetes dos capitulos (a Base do
  // capitulo fica com o slot da pele, como o finder). Sem o atributo, a chave e o id do produto, como sempre.
  function readSelectorState(selector) {
    var estado = { porProduto: {}, total: '', compare: '', variantId: '', pronto: false };
    if (!selector) return estado;
    var porSlot = selector.hasAttribute('data-bundle-slots');
    if (porSlot) {
      estado.porSlot = true;
      estado.primeiroDoProduto = {};
    }

    var cards = selector.querySelectorAll('.bundle-card');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      var id = card.getAttribute('data-component-product-id') || '';
      if (!id) continue;
      var chave = porSlot ? card.getAttribute('data-slot-index') || '' : id;
      if (!chave) continue;
      var escolhido = card.querySelector('label.swatch.swatch--selected');
      var nomeEl = card.querySelector('[data-pill-name]');
      estado.porProduto[chave] = {
        temSwatch: !!card.querySelector('label.swatch'),
        tom: escolhido && nomeEl ? (nomeEl.textContent || '').trim() : '',
        // Cor e imagem vem das custom properties do proprio label
        // (snippets/biobio-bundle-swatch.liquid), nunca de metafield lido de novo.
        cor: escolhido ? escolhido.style.getPropertyValue('--swatch-bg').trim() : '',
        imagem: escolhido ? escolhido.style.getPropertyValue('--swatch-image').trim() : '',
      };
      if (porSlot && !estado.primeiroDoProduto[id]) estado.primeiroDoProduto[id] = estado.porProduto[chave];
    }

    var totalEl = selector.querySelector('[data-bundle-total]');
    var compareEl = selector.querySelector('[data-bundle-compare]');
    var variantEl = selector.querySelector('[data-bundle-variant-id]');
    var addBtn = selector.querySelector('[data-bundle-add-to-cart]');

    if (totalEl) estado.total = (totalEl.textContent || '').trim();
    if (compareEl && !compareEl.hidden) estado.compare = (compareEl.textContent || '').trim();
    if (variantEl) estado.variantId = variantEl.value || '';
    estado.pronto = !!(addBtn && !addBtn.disabled);
    return estado;
  }

  function pintarPonto(dot, item) {
    if (item && item.cor) dot.style.setProperty('--swatch-bg', item.cor);
    else dot.style.removeProperty('--swatch-bg');
    if (item && item.imagem) dot.style.setProperty('--swatch-image', item.imagem);
    else dot.style.removeProperty('--swatch-image');
    dot.classList.toggle('is-set', !!(item && (item.cor || item.imagem)));
  }

  // Preco com o prefixo acessivel "De "/"Por " preservado (copy aprovada, Tarefa 8):
  // trocar so o textContent apagaria o <span class="visually-hidden"> do Liquid.
  function escreverPreco(el, prefixo, valor) {
    var oculto = document.createElement('span');
    oculto.className = 'visually-hidden';
    oculto.textContent = prefixo;
    el.textContent = '';
    el.appendChild(oculto);
    el.appendChild(document.createTextNode(valor));
  }

  function atualizarBarra(estado) {
    if (!garantirBarra()) return;
    var dots = bar.querySelectorAll('[data-trio-bar-dot]');
    var frases = [];
    for (var i = 0; i < dots.length; i++) {
      var dot = dots[i];
      // Com slots, o ponto leva o data-slot-index do card (ver readSelectorState).
      var item = estado.porProduto[dot.getAttribute(estado.porSlot ? 'data-slot-index' : 'data-component-product-id')];
      pintarPonto(dot, item);
      // Frase da copy aprovada: "Tom da Base: #300 Castanha. Cor do BBS: Amora." So
      // componente com tom escolhido entra; o Po (sem tom) nunca.
      if (item && item.tom && dot.hasAttribute('data-tem-tom')) {
        frases.push((dot.getAttribute('data-rotulo') || '') + ': ' + item.tom + '.');
      }
    }

    var tonesEl = bar.querySelector('[data-trio-bar-tones]');
    var frase = frases.join(' ');
    if (tonesEl && tonesEl.textContent !== frase) tonesEl.textContent = frase;

    var totalEl = bar.querySelector('[data-trio-bar-total]');
    if (totalEl && estado.total) escreverPreco(totalEl, 'Por ', estado.total);

    var compareEl = bar.querySelector('[data-trio-bar-compare]');
    if (compareEl) {
      if (estado.compare) {
        escreverPreco(compareEl, 'De ', estado.compare);
        compareEl.hidden = false;
      } else {
        compareEl.hidden = true;
      }
    }

    // Barra e botao do heroi no desktop ([data-trio-open-bundle]) sao a MESMA acao com os
    // mesmos rotulos (copy aprovada): trocam juntos.
    var ctas = [bar.querySelector('[data-trio-bar-cta]')].concat(
      Array.prototype.slice.call(document.querySelectorAll('[data-trio-open-bundle][data-label-ready]'))
    );
    // Tarefa 13 (item 1): trocou o tom depois do add, a selecao ja nao e a que foi para o carrinho e o
    // CTA volta a ser o de compra.
    if (varianteAdicionada && estado.variantId !== varianteAdicionada) varianteAdicionada = null;
    var verCarrinho = !!varianteAdicionada;
    ctas.forEach(function (cta) {
      if (!cta) return;
      var rotulo = verCarrinho ? ROTULO_VER_CARRINHO : estado.pronto ? cta.dataset.labelReady : cta.dataset.labelIncomplete;
      if (rotulo && cta.textContent.trim() !== rotulo) cta.textContent = rotulo;
      // O nome acessivel e o proprio texto (sem aria-label), entao muda junto. "Ver carrinho" abre o
      // carrinho do tema, que nao e um dialogo: sai o aria-haspopup, que volta com o estado de compra.
      // A classe toggle-cart-summary (C4, ver abrirCarrinhoDoTema) faz o toque da cliente no CTA ser
      // tratado pelo proprio toggle do tema, o mesmo do icone de carrinho do cabecalho.
      if (verCarrinho) {
        cta.setAttribute('data-trio-ver-carrinho', '');
        cta.removeAttribute('aria-haspopup');
        cta.classList.add('toggle-cart-summary');
      } else {
        cta.removeAttribute('data-trio-ver-carrinho');
        cta.setAttribute('aria-haspopup', 'dialog');
        cta.classList.remove('toggle-cart-summary');
      }
    });
  }

  // Tarefa 13 (item 1): o add bem-sucedido do seletor e o sinal que o proprio tema da no botao, a
  // classe product-add--added: posta no sucesso do /cart/add.js pelo theme.applyAjaxToProductForm (500 ms
  // depois, nesta pagina de produto) e pelo recuo de page template do biobio-bundle-selector.js. Vale
  // para o seletor inline e para o do drawer, que sao o MESMO no movido por portal, entao cobre os tres
  // caminhos (barra, drawer, seletor inline).
  //
  // A variante adicionada e a do ENVIO (fix round 1 da T13, C8 da revisao): o campo id do form lido no
  // `submit`, em captura no document, antes do handler do tema (que serializa o form nesse mesmo evento) e
  // antes do recuo de page template do biobio-bundle-selector.js (que le o mesmo campo). Os dois caminhos
  // de adicao comecam pelo submit desse form. Antes o id era lido quando a classe chegava, 500 ms depois do
  // sucesso: uma troca de tom nessa janela ficava marcada como adicionada e a barra dizia "Ver carrinho"
  // para um tom que nao entrou no carrinho. Com o id do envio, o sincronizar ve que a selecao da tela ja
  // e outra e devolve o estado de compra.
  var botaoAddObservado = null;
  var idDoEnvio = null;

  function registrarEnvio(event) {
    var form = event.target;
    if (!form || !form.classList || !form.classList.contains('bundle-cta__form')) return;
    if (!form.closest('bundle-selector')) return;
    var campo = form.querySelector('[name="id"]');
    idDoEnvio = campo && campo.value ? campo.value : null;
  }

  function observarAdd() {
    var seletor = selectorNode();
    var btn = seletor ? seletor.querySelector('[data-bundle-add-to-cart]') : null;
    if (!btn || btn === botaoAddObservado || !window.MutationObserver) return;
    botaoAddObservado = btn;
    var tinha = btn.classList.contains('product-add--added');
    new MutationObserver(function () {
      var tem = btn.classList.contains('product-add--added');
      if (tem && !tinha && idDoEnvio) {
        varianteAdicionada = idDoEnvio;
        geracaoDoAdd++;
        idDoEnvio = null;
        sincronizar(btn.closest('bundle-selector'));
      }
      tinha = tem;
    }).observe(btn, { attributes: true, attributeFilter: ['class'] });
  }

  // "Ver carrinho" (fix round 1 da T13, C4 da revisao): o resumo do tema abre pelo caminho do icone de
  // carrinho do cabecalho, o toggle .toggle-cart-summary do proprio tema, sem buscar nada. No estado "Ver
  // carrinho" o CTA leva essa classe (atualizarBarra), entao o toque da cliente e tratado pelo handler
  // delegado do tema no document, na hora: show-cart-summary no body e o foco no fechar. A adicao ja
  // deixou o resumo pronto com a linha do trio (o updateCartSummaries do add), e o C3 garante que a barra
  // so diz "Ver carrinho" enquanto o trio segue no carrinho. Antes o toque chamava o updateCartSummaries,
  // que busca a /search inteira (397 KB, 0,4 s no dev local) antes de abrir, com o spinner do tema dentro
  // do resumo ainda fechado: nada mudava na tela nesse meio tempo (medido: 0,5 a 0,6 s do toque ao painel).
  // Nem clique sintetico no icone (o GTM contava um gtm.click a mais, no icone, que a cliente nao deu) nem
  // o trigger do jQuery global (nao e a instancia em que o tema registrou os handlers: o trigger nao abre
  // nada). Esta funcao e so o recuo: roda depois do despacho do toque (setTimeout no handler do CTA) e,
  // se o tema nao abriu o resumo (toggle ausente ou resumo lateral desligado), usa o caminho antigo
  // (theme.updateCartSummaries); tema em modo pagina de carrinho, ou sem a funcao: /cart.
  function abrirCarrinhoDoTema() {
    var t = window.theme;
    var modoPagina = !!(t && t.settings && t.settings.cartType === 'page');
    if (document.body.classList.contains('show-cart-summary')) return;
    if (t && typeof t.updateCartSummaries === 'function' && !modoPagina) {
      try {
        t.updateCartSummaries(true, false, false);
        return;
      } catch (e) {
        console.warn('[trio] updateCartSummaries falhou; indo pro /cart', e);
      }
    }
    window.location.href = '/cart';
  }

  // Fix round 1 da T13 (C3 da revisao): "Ver carrinho" so vale enquanto a variante adicionada ainda esta
  // no carrinho. A cliente pode tirar o trio (ou zerar a quantidade) no carrinho lateral, ou voltar pelo
  // bfcache depois do checkout, e a barra seguia abrindo um carrinho vazio ate ela trocar um tom. Le o
  // /cart.js e, se a variante nao estiver mais la, volta ao estado de compra (o mesmo sincronizar da troca
  // de tom). Falha de rede ou resposta que nao e carrinho nao muda nada; uma resposta que chega depois de
  // um add novo (de outra variante ou da mesma) e ignorada, porque foi lida antes dele. Quem chama: ver os
  // gatilhos em initEventos.
  function conferirVarianteNoCarrinho() {
    var alvo = varianteAdicionada;
    var geracao = geracaoDoAdd;
    if (!alvo || !window.fetch) return;
    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      })
      .then(function (carrinho) {
        if (!carrinho || !Array.isArray(carrinho.items) || varianteAdicionada !== alvo || geracaoDoAdd !== geracao) return;
        // Kits vendidos como itens avulsos no 10.10 (spec docs/specs/2026-10-08-kits-avulsos-10-10-design.md
        // no worktree do calendario): com o seletor em modo avulso, o carrinho tem os componentes com _kit,
        // nunca a variante do kit. Fora do modo (sem o atributo) a conferencia e a de sempre.
        var seletorKit = selectorNode();
        var kitAvulso = seletorKit && seletorKit.getAttribute('data-kit-avulso') === '1' ? seletorKit.getAttribute('data-kit-avulso-handle') : null;
        var esta = carrinho.items.some(function (item) {
          return String(item.variant_id) === alvo || String(item.id) === alvo ||
            (!!kitAvulso && !!item.properties && item.properties._kit === kitAvulso);
        });
        if (!esta) {
          varianteAdicionada = null;
          sincronizar(null);
        }
      })
      .catch(function () {
        /* sem leitura, o estado fica como esta */
      });
  }

  // Filete de cor dos capitulos (sections/biobio-trio-capitulo.liquid): a Tarefa
  // 4 plantou `data-component-product-id` justamente pra casar por ID de
  // produto, nunca por handle. Swatch so de imagem (sem cor) mantem o filete no
  // fallback neutro: o filete e uma faixa de cor solida, nao um retrato.
  function atualizarFiletes(estado) {
    var filetes = document.querySelectorAll('.trio-capitulo__filete[data-component-product-id]');
    for (var i = 0; i < filetes.length; i++) {
      var filete = filetes[i];
      var item = (estado.porSlot ? estado.primeiroDoProduto : estado.porProduto)[filete.getAttribute('data-component-product-id')];
      if (item && item.cor) filete.style.setProperty('--trio-chapter-color', item.cor);

      if (!item || !item.tom) continue;
      var secao = filete.closest('.trio-capitulo');
      var nomeEl = secao ? secao.querySelector('.trio-capitulo__seu-tom-nome') : null;
      if (nomeEl) nomeEl.textContent = item.tom;
    }
  }

  // Rodada final da v2.1 (F5): os radiogroups do seletor compartilhado se chamam "Selecionado" (o
  // aria-labelledby do snippets/biobio-bundle-card.liquid aponta para esse span, igual em todo cartao).
  // So nesta pagina, cada grupo ganha como nome o rotulo que a barra ja usa para o mesmo produto
  // (data-rotulo do ponto: "Tom da Base", "Cor do BBS"), sem texto novo, e perde o aria-labelledby, que
  // teria precedencia sobre o aria-label. O snippet nao muda, e a PDP de bundle fora desta pagina segue
  // como esta. Idempotente: roda a cada sincronizar, entao cobre o seletor inline, o do drawer (o mesmo
  // no) e um seletor novo depois de re-render da section.
  // Kit com slots (data-bundle-slots no seletor): o ponto do mesmo slot (data-slot-index), porque as duas Bases tem o
  // mesmo id de produto e o contorno ficaria com o nome da pele (ver readSelectorState).
  function nomearGrupos(selector) {
    var porSlot = selector.hasAttribute('data-bundle-slots');
    var cards = selector.querySelectorAll('.bundle-card');
    for (var i = 0; i < cards.length; i++) {
      var grupo = cards[i].querySelector('[role="radiogroup"]');
      var pid = cards[i].getAttribute('data-component-product-id');
      if (!grupo || !pid) continue;
      var ponto = porSlot
        ? document.querySelector('[data-trio-bar-dot][data-slot-index="' + cssEscape(cards[i].getAttribute('data-slot-index') || '') + '"]')
        : document.querySelector('[data-trio-bar-dot][data-component-product-id="' + cssEscape(pid) + '"]');
      var rotulo = ponto ? (ponto.getAttribute('data-rotulo') || '').trim() : '';
      if (!rotulo) continue;
      if (grupo.getAttribute('aria-label') !== rotulo) grupo.setAttribute('aria-label', rotulo);
      if (grupo.hasAttribute('aria-labelledby')) grupo.removeAttribute('aria-labelledby');
    }
  }

  function sincronizar(selector) {
    var alvo = selector || selectorNode();
    if (!alvo) return;
    nomearGrupos(alvo);
    var estado = readSelectorState(alvo);
    atualizarBarra(estado);
    atualizarFiletes(estado);
  }

  /* ================================================================ */
  /* Barra fixa: portal pro body e reserva de espaco no rodape          */
  /* ================================================================ */

  function medirBarra() {
    if (!bar) return;
    var h = bar.offsetHeight;
    if (h > 0) document.documentElement.style.setProperty('--trio-bar-h', h + 'px');
  }

  // A barra so existe visualmente depois de estar portada pro <body>: o CSS a
  // esconde com `display: none` e quem revela e a classe `has-trio-bar`, escrita
  // aqui, na mesma volta do append. Sem isso havia uma janela real (o tempo entre
  // o navegador pintar a section e este script rodar) com a barra VISIVEL, sem
  // listener e, pior, com `position: fixed` DENTRO da section, que e exatamente o
  // caso que o iOS trata como estatico. Barra visivel e inerte e pior que barra
  // que aparece 200ms depois.
  var barraObservada = false;

  function garantirBarra() {
    if (bar && bar.isConnected) return bar;
    if (!document.body) return null;
    var b = document.querySelector('[data-trio-bar]');
    if (!b) return null;
    // Filha direta do body (fixed a prova de overflow-x) mas ANTES do bloco que
    // contem o heroi: na ordem de tab a barra vem logo depois do cabecalho do
    // tema, nao 58 tabs depois, no fim do documento (auditoria 18/09, achado 13).
    if (b.parentElement !== document.body) {
      var ancora = document.querySelector('.biobio-trio-hero-section');
      while (ancora && ancora.parentElement && ancora.parentElement !== document.body) ancora = ancora.parentElement;
      if (ancora && ancora.parentElement === document.body) document.body.insertBefore(b, ancora);
      else document.body.appendChild(b);
    }
    bar = b;
    document.body.classList.add('has-trio-bar');
    medirBarra();
    // A barra quebra de linha em telas estreitas e com zoom de texto; sem
    // remedir, a folga do rodape ficaria menor que a barra e cobriria a FAQ.
    if (!barraObservada) {
      barraObservada = true;
      if (window.ResizeObserver) {
        new ResizeObserver(function () {
          medirBarra();
        }).observe(bar);
      } else {
        window.addEventListener('resize', medirBarra);
      }
    }
    return bar;
  }

  /* ================================================================ */
  /* Videos sob demanda (Tarefa 10 de agosto: trilho; PDP v2, Tarefa 9: */
  /* blocos). PORTADO de assets/biobio-lp.js, nao importado (ver Peca 5 */
  /* no comentario do topo do arquivo). Contrato por atributo:          */
  /* video[data-trio-lazy-video][data-src] em [data-trio-video-frame].  */
  /* ================================================================ */

  var VIDEO_LAZY = 'video[data-trio-lazy-video]';

  // Fonte do video (fix rounds 2 e 3 da T9, rulings do controlador): o master HLS do data-src-hls
  // so quando as duas coisas valem, o layout de celular (o V2, max-width 989px como em
  // assets/biobio-trio.css, video com ~147px de largura) E o navegador toca HLS nativo (Safari e
  // iOS, inclusive o navegador do Instagram no iPhone; o Chromium 147 do harness tambem responde
  // "maybe"). Nos demais, o MP4 do data-src: no desktop o video e grande, e medido no fix round 2
  // o Chrome sobe o HLS para a 1080p em .ts, mais pesada que o MP4. Decidido na hora de carregar;
  // um resize depois nao troca a fonte. Sem dependencia nova.
  var HLS_MIME = 'application/vnd.apple.mpegurl';
  var LAYOUT_CELULAR = '(max-width: 989px)';

  function fonteDoVideo(video) {
    var hls = video.dataset.srcHls;
    if (hls && window.matchMedia(LAYOUT_CELULAR).matches && video.canPlayType(HLS_MIME) !== '') {
      recuarParaMp4SeFalhar(video);
      return hls;
    }
    return video.dataset.src;
  }

  // Recuo (fix round 3): se o HLS falhar (evento error no <video>, com video.error preenchido), o
  // video troca UMA vez para o MP4 do data-src. O mudo fica como estava (muted nao muda com o src)
  // e o video so volta a tocar se devia estar tocando. A intencao vem dos eventos play e pause, nao
  // de video.paused: medido, no listener de error do proprio elemento o Chromium ja devolve paused
  // true (sem evento pause) mesmo com um play em curso; o WebKit devolve false. Os listeners saem na
  // primeira troca, entao um erro do MP4 depois disso nao troca de novo: nunca entra em laco.
  function recuarParaMp4SeFalhar(video) {
    if (video.__trioRecuoArmado) return;
    video.__trioRecuoArmado = true;
    var querTocar = false;
    function marcarPlay() { querTocar = true; }
    function marcarPause() { querTocar = false; }
    video.addEventListener('play', marcarPlay);
    video.addEventListener('pause', marcarPause);
    video.addEventListener('error', function recuar() {
      if (!video.error || !video.dataset.src) return;
      video.removeEventListener('error', recuar);
      video.removeEventListener('play', marcarPlay);
      video.removeEventListener('pause', marcarPause);
      video.src = video.dataset.src;
      if (querTocar) {
        var promessa = video.play();
        if (promessa && typeof promessa.catch === 'function') {
          promessa.catch(function () {
            sincronizarPlay(video);
          });
        }
      }
    });
  }

  function reduceMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  // Poster sob demanda (Tarefa 11.1, minor 3 da revisao final). Os videos declaram o poster em
  // data-poster (desktop) e data-poster-mobile (abaixo de 750px, largura menor, feita para o tamanho
  // exibido); o atributo poster so entra quando o video chega perto: pelo observadorPosters (300px
  // ANTES de o video entrar pela parte de baixo da tela, sem limite de area) ou, antes dele, na hora
  // em que o video carrega por qualquer caminho (autoplay, toque, som). Sem isto os dez posters da
  // pagina baixavam no carregamento. Idempotente: um poster ja posto nao muda. A excecao e o bloco com o
  // setting poster_imediato (o bloco 1, cuja ponta aparece na primeira tela): um script inline em
  // sections/biobio-trio-bloco.liquid poe o poster no parse, com a MESMA escolha de largura daqui, e
  // esse video nem entra no observadorPosters (so observa quem ainda nao tem poster).
  var LAYOUT_POSTER_CELULAR = '(max-width: 749px)';

  function aplicarPoster(video) {
    if (video.hasAttribute('poster')) return;
    var celular = window.matchMedia(LAYOUT_POSTER_CELULAR).matches;
    var url = (celular && video.getAttribute('data-poster-mobile')) || video.getAttribute('data-poster');
    if (url) video.setAttribute('poster', url);
  }

  function carregarVideo(video) {
    aplicarPoster(video);
    if (!video.src && video.dataset.src) video.src = fonteDoVideo(video);
  }

  function botaoDoQuadro(video, seletor) {
    var frame = video.closest('[data-trio-video-frame]');
    return frame ? frame.querySelector(seletor) : null;
  }

  // Unico ponto que sincroniza audio com o botao de som (aria-label e classe
  // is-on), mesmo padrao de assets/biobio-lp.js:muteVideo. O botao NAO e toggle:
  // o rotulo ja diz a acao ("Ativar som" / "Desativar som", copy aprovada), entao
  // sem aria-pressed. Com os dois, o leitor de tela anunciava "Desativar som,
  // pressionado", lido como "mudo ligado" (revisao da T9, I1). O laranja e a
  // troca de icone moram na classe is-on.
  function sincronizarSom(video) {
    var button = botaoDoQuadro(video, '[data-trio-sound]');
    if (!button) return;
    var ligado = !video.muted;
    button.removeAttribute('aria-pressed');
    button.setAttribute('aria-label', ligado ? 'Desativar som' : 'Ativar som');
    button.classList.toggle('is-on', ligado);
  }

  function muteVideoTrilho(video) {
    video.muted = true;
    sincronizarSom(video);
  }

  // Silencia todo video do contrato que estiver com som (o video segue tocando mudo). Chamado ao
  // abrir um modal: o lightbox (revisao da T9, M2) e o drawer (Tarefa 11.1, minor 4).
  function silenciarVideos() {
    document.querySelectorAll(VIDEO_LAZY).forEach(function (outro) {
      if (!outro.muted) muteVideoTrilho(outro);
    });
  }

  // Botao "Assistir ao trecho" (blocos): toggle com rotulo FIXO e aria-pressed
  // espelhando o estado real do video (play/pause), venha a mudanca de onde vier
  // (IntersectionObserver, o proprio botao, controles nativos, e a tela cheia:
  // desde a Tarefa 13 o toque no video abre o lightbox, que para o video da
  // pagina enquanto esta aberto e o retoma ao fechar).
  function sincronizarPlay(video) {
    var button = botaoDoQuadro(video, '[data-trio-play]');
    if (!button) return;
    button.setAttribute('aria-pressed', video.paused ? 'false' : 'true');
  }

  // Tocar/pausar por gesto da cliente no botao de play, o unico jeito de pausar
  // sem sair da pagina (o toque no video abre a tela cheia desde a Tarefa 13,
  // ver o delegado de [data-trio-video-abrir]). Pausa
  // pedida pela cliente fica marcada (userPaused) pra o IntersectionObserver
  // nao retomar sozinho quando o video volta a ficar em vista. O botao espelha
  // na hora (play()/pause() mudam `paused` de forma sincrona; os eventos play e
  // pause so chegam uma tarefa depois), e o catch devolve o estado se o
  // navegador recusar o play.
  function alternarVideo(video) {
    if (video.paused) {
      delete video.dataset.userPaused;
      carregarVideo(video);
      var promessa = video.play();
      if (promessa && typeof promessa.catch === 'function') {
        promessa.catch(function () {
          sincronizarPlay(video);
        });
      }
    } else {
      video.dataset.userPaused = '1';
      video.pause();
    }
    sincronizarPlay(video);
  }

  // Dois observadores (fix round 4 da T9): observadorVideos so INICIA o autoplay; observadorForaDaTela
  // so pausa e muta quando o video sai da tela inteira. O terceiro (Tarefa 11.1) so poe o poster.
  var observadorVideos = null;
  var observadorForaDaTela = null;
  var observadorPosters = null;

  // O markup do trilho e dos blocos e HTML estatico das proprias sections (nao
  // um fragmento buscado depois), e este arquivo so executa apos o documento
  // inteiro parsear (defer): os players ja existem no DOM na primeira chamada,
  // por isso initVideoTrilho() roda no boot sincrono, junto de garantirDrawer().
  // Idempotente por video (marca __trioObservado): bootTardio() e o
  // shopify:section:load do editor chamam de novo e so os videos novos entram.
  function initVideoTrilho() {
    var players = document.querySelectorAll(VIDEO_LAZY + '[data-src]');
    if (!players.length) return;

    var load = carregarVideo;

    if (!('IntersectionObserver' in window)) {
      // Fallback sem IntersectionObserver: carrega tudo, sem autoplay,
      // controles nativos assumem a reproducao.
      players.forEach(function (video) {
        if (video.__trioObservado) return;
        video.__trioObservado = true;
        load(video);
        video.setAttribute('controls', 'controls');
      });
      return;
    }

    if (!observadorVideos) {
      observadorVideos = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            var video = entry.target;
            load(video);
            // Sob prefers-reduced-motion nada toca sozinho. Ate a Tarefa 13 o video ganhava aqui os
            // controles nativos; agora o botao de tela cheia fica por cima dele (o toque abre a tela
            // cheia, parada e com os controles nativos), e uma barra de controles coberta seria um
            // controle morto. Os botoes proprios de play e som somem, nos blocos e nos cartoes, pela
            // media query de movimento reduzido do assets/biobio-trio.css (fix round 1 da T13, C2: o
            // seletor dos cartoes dependia do [controls] que o video deixou de ganhar).
            // Nem o video que esta aberto na tela cheia (Tarefa 13): ele fica parado atras dela, e o
            // primeiro retorno do observador depois do boot (um toque na fila antes do boot abre a tela
            // cheia) o poria para tocar de novo.
            if (!reduceMotion() && !video.dataset.userPaused && !video.hasAttribute('data-trio-em-tela-cheia')) {
              video.play().catch(function () {});
            }
          });
        },
        // rootMargin de baixo em -25% (fix round 1 da T9): a faixa de baixo da tela nao conta
        // como "em vista" para COMECAR o autoplay. Com o layout V2 do mobile o bloco 1 ficou curto
        // e o video dele aparecia na primeira tela (105 de 261px a 390x844, 58% a 430x932):
        // passava dos 40%, tocava e baixava o trecho no carregamento, antes de a cliente rolar.
        // Essa faixa e tambem onde a barra fixa fica por cima.
        { threshold: 0.4, rootMargin: '0px 0px -25% 0px' }
      );
      // Pausar e mutar fora da tela e de outro observador, no viewport inteiro (fix round 4 da
      // T9, re-revisao dos rounds 1 a 3). Com o pause no observador do autoplay, um video tocado
      // pela cliente na faixa de baixo seguia tocando depois de sair da tela (o observador ia de
      // "fora" para "fora" e nunca disparava), e um toque nessa faixa antes do boot era desfeito
      // pelo primeiro callback (pausava em t=0). Aqui so pausa o que saiu da tela INTEIRA:
      // nenhum video que a cliente pos para tocar e pausado enquanto ainda aparece.
      observadorForaDaTela = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) return;
            var video = entry.target;
            video.pause();
            if (!video.muted) muteVideoTrilho(video);
          });
        },
        { threshold: 0 }
      );
      // Poster (Tarefa 11.1): o video a menos de 300px de entrar pela parte de baixo da tela ja ganha o
      // poster, antes de aparecer. A primeira versao usava a mesma margem do autoplay (-25%, so acima da
      // linha de 75% da tela) e um quadro PARADO entre o topo da barra e essa linha ficava vazio na tela
      // (147px a 390x844, 161px a 1440x900; fix round da revisao da T11.1). O autoplay continua com a
      // margem dele: o poster e barato, o trecho nao. Na primeira carga o bloco 2 fica de 489 a 625px
      // abaixo da dobra nos cinco viewports medidos, entao os 300px nao trazem nenhum poster de volta
      // ao carregamento (o do bloco 1 e imediato, pelo poster_imediato). No carrossel, o primeiro
      // cartao que chega poe o poster do trilho inteiro: os cartoes de fora da tela no eixo X nunca
      // cruzam o viewport sozinhos, e arrastar mostraria cartao vazio.
      observadorPosters = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            var trilho = entry.target.closest('[data-trio-video-track]');
            var alvos = trilho ? Array.prototype.slice.call(trilho.querySelectorAll(VIDEO_LAZY)) : [entry.target];
            alvos.forEach(function (v) {
              aplicarPoster(v);
              observadorPosters.unobserve(v);
            });
          });
        },
        { threshold: 0, rootMargin: '0px 0px 300px 0px' }
      );
    }
    players.forEach(function (video) {
      if (video.__trioObservado) return;
      video.__trioObservado = true;
      observadorVideos.observe(video);
      observadorForaDaTela.observe(video);
      if (!video.hasAttribute('poster')) observadorPosters.observe(video);
    });
  }

  /* ================================================================ */
  /* Ligacoes                                                           */
  /* ================================================================ */

  // isPlainLeftClick saiu daqui no Fix round 1 da Tarefa 8: a checagem
  // equivalente agora vive no <script> inline de sections/biobio-trio-hero.liquid,
  // junto com o proprio preventDefault do gatilho de quick-shop.

  // Resolve a casca do drawer SOB DEMANDA (na execucao do script e, se ela ainda
  // nao existir, no primeiro clique). Idempotente e barato: sai na primeira linha
  // quando ja resolvido.
  function garantirDrawer() {
    if (drawer && drawer.isConnected) return drawer;
    if (!document.body) return null;
    var d = document.querySelector('[data-trio-drawer]');
    if (!d) return null;
    if (d.parentElement !== document.body) document.body.appendChild(d);

    drawer = d;
    var eyebrowDaPagina = d.getAttribute('data-trio-eyebrow') || 'Trio Essencial BioBio';
    var tituloCompraDaPagina = d.getAttribute('data-trio-titulo-compra') || 'Comprar o trio';
    MODES.bundle.eyebrow = eyebrowDaPagina;
    MODES.bundle.title = tituloCompraDaPagina;
    MODES.finder.eyebrow = eyebrowDaPagina;
    panel = d.querySelector('[data-trio-drawer-panel]');
    titleEl = d.querySelector('[data-trio-drawer-title]');
    eyebrowEl = d.querySelector('[data-trio-drawer-eyebrow]');
    statusEl = d.querySelector('[data-trio-drawer-status]');
    backEl = d.querySelector('[data-trio-drawer-back]');
    views = {};
    d.querySelectorAll('[data-trio-view]').forEach(function (view) {
      views[view.getAttribute('data-trio-view')] = view;
    });
    return drawer;
  }

  /* ================================================================ */
  /* Finder de tom residente (Tarefa 9): view estatica, zero fetch      */
  /* ================================================================ */

  // Diferente de quickshop, a view finder ja vem populada em Liquid por
  // snippets/biobio-quick-shop.liquid (biobio-tone-finder-core com modo:
  // 'aplicar'). Abrir e so trocar de view; nao ha rede nem re-render.
  //
  // Se o drawer ja estiver aberto em OUTRO modo (o gatilho "Nao sabe seu
  // tom?" dentro do quick-shop da Base -- ver
  // snippets/biobio-quick-shop-content.liquid), a view atual entra na pilha
  // local pra o botao Voltar restaurar exatamente o que a cliente estava
  // vendo. Abrir a partir de FORA do drawer (link do heroi, drawer fechado)
  // nao empilha nada: openMode e null nesse caso, nao ha view "abandonada".
  function openFinder(detail) {
    if (openMode && openMode !== 'finder') {
      viewStack.push({ mode: openMode, cfg: currentCfg });
    }
    // openDrawer ja chama updateBackButton() no fim -- reflete a pilha logo
    // apos o push acima.
    var abriu = openDrawer('finder', { trigger: detail && detail.trigger, cfg: MODES.finder });
    if (abriu) esperarCssDoFinder(views.finder);
  }

  // CSS do finder fora do caminho critico (Tarefa 11.1, minor 7 da revisao final). O heroi carrega
  // assets/biobio-tone-finder.css com media="print" e onload troca para "all" (nao bloqueia a pintura
  // nem os scripts defer). Se o finder abrir antes de o arquivo chegar (toque cedo, rede lenta), a view
  // fica invisivel (data-trio-aguardando-css, visibility: hidden no biobio-trio.css) ate ele carregar,
  // com "Carregando..." no status: nunca aparece sem estilo. Erro ou demora de mais de 4 s mostra assim
  // mesmo, porque o finder sem estilo ainda funciona e um drawer vazio nao.
  function esperarCssDoFinder(view) {
    var link = document.querySelector('link[data-trio-finder-css]');
    if (!view || !link) return;
    if (link.sheet) {
      if (link.media !== 'all') link.media = 'all';
      return;
    }
    var feito = false;
    var pronto = function () {
      if (feito) return;
      feito = true;
      link.removeEventListener('load', pronto);
      link.removeEventListener('error', pronto);
      if (link.media !== 'all') link.media = 'all';
      view.removeAttribute('data-trio-aguardando-css');
      if (statusEl && statusEl.textContent === 'Carregando...') setStatus('');
    };
    view.setAttribute('data-trio-aguardando-css', '');
    setStatus('Carregando...');
    link.addEventListener('load', pronto);
    link.addEventListener('error', pronto);
    setTimeout(pronto, 4000);
  }

  /* ---------------------------------------------------------------- */
  /* Finder so com os tons do kit (Tarefa 11.1, I5 da revisao final e */
  /* decisao do Breno de 24/09).                                        */
  /* ---------------------------------------------------------------- */

  // O finder residente e o compartilhado (assets/biobio-tone-finder.js, igual ao da pagina "Encontre
  // seu tom", que NAO muda) e recomenda os 8 tons da Base, inclusive os que o kit nao tem hoje (#700 e
  // #800 esgotados, sem reposicao); o "Usar este tom" deles terminava em erro. Aqui, e so no finder do
  // drawer do Trio, as faixas passam a conter so os tons que o kit tem: os swatches do seletor unico
  // da pagina que nao estao desabilitados. Esse seletor e renderizado pelo biobio-bundle-card com a
  // regra do commit 402b590 (esgotado e fora de linha somem, fail-open), entao "o que o kit tem" e
  // exatamente o que o "Usar este tom" consegue aplicar.
  //
  // COMO. O finder le data-faixa do botao da faixa na hora do clique e data-faixa-swatches ao pintar os
  // pontos, na inicializacao. Este codigo reescreve os dois atributos, tirando os codigos fora do kit,
  // ANTES de o finder iniciar: os dois scripts carregam com defer no heroi, este primeiro, e defer roda
  // na ordem do documento. A escada fica como e (100,200 | 300,400 | 500,700 | 600,800, sem "corrigir"
  // a ordem); o desempate por subtom acontece so entre os tons do kit (500,700 vira 500 e 600,800 vira
  // 600). Se o finder ja tiver pintado os pontos (ordem diferente de carga), eles sao refeitos.
  //
  // FAIXA SEM NENHUM TOM NO KIT: o finder nao tem o que mostrar (e o resultado anterior ficaria na
  // tela), entao esta pagina mostra a mensagem de indisponivel no lugar do resultado e esconde o passo
  // do subtom, sem mandar escolher "na etapa de compra" um tom que nao existe.
  //
  // SEM SELETOR (PDP v2 da Base, Task 4): os swatches lidos sao os do <pdp-offer> (swatchesDeTom), que
  // tambem tiram as variantes ocultas e desabilitam as esgotadas, entao a regra e a mesma.
  //
  // FAIL-OPEN: sem seletor, sem JSON do finder ou sem nenhum tom do finder no seletor (dado quebrado),
  // nada e reescrito e o finder fica como o compartilhado. BASE INTEIRA ESGOTADA e o contrario de dado
  // quebrado (fix round da revisao da T11.1): o cartao da Base cai no fail-open do 402b590 e mostra
  // todos os tons DESABILITADOS; o kit nao tem nenhum tom, entao TODA faixa fica vazia e mostra a
  // mensagem de indisponivel (antes o finder voltava a recomendar os 8 tons).
  var FINDER_DO_DRAWER = '[data-trio-view="finder"] biobio-tone-finder';
  var TEXTO_FAIXA_SEM_TOM = 'Os tons desta faixa estão indisponíveis no Trio agora.';
  // Sem <bundle-selector> (PDP v2 da Base, Task 4, ruling R11): a pagina nao vende o Trio, entao o texto
  // nao fala dele. Escolhido na hora de escrever (mostrarFaixaSemTom).
  var TEXTO_FAIXA_SEM_TOM_OFERTA = 'Os tons desta faixa estão indisponíveis agora.';

  function restringirFinderAoKit() {
    var finder = document.querySelector(FINDER_DO_DRAWER);
    if (!finder || finder.hasAttribute('data-trio-tons-do-kit')) return;
    var swatches = swatchesDeTom();
    var dadosEl = finder.querySelector('[data-tone-variants]');
    if (!swatches.length || !dadosEl) return;
    var dados;
    try {
      dados = JSON.parse(dadosEl.textContent);
    } catch (e) {
      return;
    }
    var noSeletor = {};
    var noKit = {};
    swatches.forEach(function (l) {
      var id = l.getAttribute('data-variant-id');
      noSeletor[id] = true;
      if (!l.classList.contains('swatch--disabled')) noKit[id] = true;
    });
    var codigos = {};
    var cores = {};
    var baseNoSeletor = false;
    dados.forEach(function (v) {
      var m = /#(\d{3})/.exec(v.titulo || '');
      if (!m) return;
      cores[m[1]] = v.hex;
      if (noSeletor[String(v.id)]) baseNoSeletor = true;
      if (noKit[String(v.id)]) codigos[m[1]] = true;
    });
    var doKit = Object.keys(codigos);
    if (!doKit.length && !baseNoSeletor) return;
    finder.setAttribute('data-trio-tons-do-kit', doKit.join(','));

    var filtrar = function (lista) {
      return (lista || '').split(',').filter(function (c) { return codigos[c]; });
    };
    finder.querySelectorAll('[data-faixa]').forEach(function (btn) {
      var ficam = filtrar(btn.getAttribute('data-faixa'));
      btn.setAttribute('data-faixa', ficam.join(','));
      if (!ficam.length) btn.setAttribute('data-trio-faixa-sem-tom', '');
    });
    finder.querySelectorAll('[data-faixa-swatches]').forEach(function (wrap) {
      var ficam = filtrar(wrap.getAttribute('data-faixa-swatches'));
      wrap.setAttribute('data-faixa-swatches', ficam.join(','));
      if (!wrap.children.length) return;
      wrap.textContent = '';
      ficam.forEach(function (c) {
        var dot = document.createElement('span');
        dot.className = 'tone-finder__dot';
        dot.style.background = cores[c];
        wrap.appendChild(dot);
      });
    });
  }

  // Resultado honesto para a faixa sem tom no kit. Roda DEPOIS do handler do proprio finder (este e
  // delegado no document, o do finder e no botao), que ja marcou a faixa e mostrou o passo do subtom.
  function mostrarFaixaSemTom(finder) {
    var passo = finder.querySelector('[data-step="subtom"]');
    if (passo) passo.hidden = true;
    var resultado = finder.querySelector('[data-result]');
    if (!resultado) return;
    resultado.hidden = false;
    resultado.textContent = '';
    var msg = document.createElement('p');
    msg.className = 'tone-finder__indisponivel';
    msg.textContent = selectorNode() ? TEXTO_FAIXA_SEM_TOM : TEXTO_FAIXA_SEM_TOM_OFERTA;
    resultado.appendChild(msg);
    // O mesmo link de atendimento que o resultado normal traz (template do core compartilhado).
    var tpl = finder.querySelector('[data-result-template]');
    var wa = tpl && tpl.content ? tpl.content.querySelector('.tone-finder__trust a') : null;
    if (wa) {
      var linha = document.createElement('p');
      linha.className = 'tone-finder__trust';
      linha.appendChild(wa.cloneNode(true));
      resultado.appendChild(linha);
    }
  }

  // CSS.escape com fallback defensivo (mesmo padrao de assets/biobio-pdp-offer.js:26):
  // todo navegador alvo desta loja tem CSS.escape, mas o guard custa zero.
  function cssEscape(s) {
    return window.CSS && CSS.escape ? CSS.escape(s) : String(s).replace(/["\\]/g, '\\$&');
  }

  // Depois de aplicar um tom (tone-finder:applied), foca o PROXIMO
  // radiogroup ainda incompleto (ex.: cor do BBS, se a cliente ainda nao
  // escolheu) pra ela continuar o fluxo de compra sem procurar. Se tudo ja
  // estiver completo, nao acha nada pra focar -- openDrawer('bundle', ...)
  // ja focou o painel antes disso, entao o foco nunca cai no vazio.
  function focusNextIncompleteGroup(selector) {
    if (!selector) return false;
    var cards = selector.querySelectorAll('.bundle-card');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      var group = card.querySelector('[role="radiogroup"]');
      if (!group) continue;
      if (card.querySelector('label.swatch.swatch--selected')) continue;
      var primeiro = group.querySelector('input[type="radio"]:not([disabled])');
      if (primeiro) {
        primeiro.focus();
        return true;
      }
    }
    return false;
  }

  // PDP v2 da Base (Task 4): "Usar este tom" numa pagina SEM <bundle-selector>. O swatch vem de
  // swatchesDeTom() (o escopo do <pdp-offer>). Sem oferta, nada a fazer e nada a dizer (Review Focus 3).
  // Tom que a oferta nao tem (oculto, esgotado, de outro produto): a mensagem de erro do caminho do
  // seletor, dentro da gaveta, que fica aberta para a cliente tentar outro resultado (Review Focus 2).
  // Com o swatch: clique no LABEL (o <pdp-offer> trata, como o toque da cliente), a gaveta fecha sem
  // devolver o foco ao gatilho, o foco vai ao radio do tom (depois do fechamento: com a gaveta aberta a
  // pagina esta inert e nao recebe foco) e "Tom aplicado" sai na regiao viva da oferta, porque o status
  // da gaveta acabou de ficar escondido junto com ela e nao anunciaria nada. Sem a regiao viva, o status.
  function aplicarTomNaOferta(id, detail) {
    if (!document.querySelector('pdp-offer')) return;
    var swatches = swatchesDeTom();
    var label = null;
    for (var i = 0; i < swatches.length; i++) {
      if (swatches[i].getAttribute('data-variant-id') === id) {
        label = swatches[i];
        break;
      }
    }
    var radio = label ? label.querySelector('input[type="radio"]') : null;
    if (!label || label.classList.contains('swatch--disabled') || !radio || radio.disabled) {
      setStatus('Não foi possível aplicar esse tom automaticamente. Escolha o tom na etapa de compra.');
      return;
    }
    // A origem se le ANTES de fechar: o closeDrawer zera o lastTrigger.
    var origemBarra = origemBarraDe(lastTrigger);
    label.click();
    closeDrawer({ restoreFocus: false });
    if (!(origemBarra && pedirFocoABarra())) radio.focus();
    var tom = (detail.variant && detail.variant.titulo) || '';
    var texto = tom ? 'Tom aplicado: ' + tom + '.' : 'Tom aplicado.';
    var anuncio = document.querySelector('pdp-offer [data-pdp-anuncio]');
    if (anuncio) anuncio.textContent = texto;
    else setStatus(texto);
  }

  // Rodada final da v2.1 (F2, decisao do Breno de 27/09): "Escolher meus tons" leva ao seletor do trio
  // o tom que a cliente escolheu na janela do produto, pelo mesmo caminho do "Descubra seu tom"
  // (tone-finder:applied): clique no label.swatch do cartao desse produto no <bundle-selector> unico,
  // achado pelo nome da opcao (o data-option-value do cartao; na janela, o titulo da variante marcada,
  // lido do JSON inline dela, primeira opcao). Chamado depois do openDrawer: o seletor ja esta no
  // drawer, e o status do cartao (regiao viva) anuncia o tom. Nada muda quando a cliente nao escolheu
  // tom nessa janela (marca data-trio-qs-tom-escolhido, ver marcarTomEscolhido), quando o produto nao
  // tem tom (Po Facial) ou quando o kit nao oferece esse tom: sem label no cartao (fora de linha ou
  // esgotado, regra 402b590) ou com o label desabilitado.
  // Kit em modo slots (data-bundle-slots no seletor; Combo Renata Meins, spec 2026-10-26): produto que ocupa mais de
  // um slot (a Base da pele e a do contorno) nao recebe o tom, porque a janela nao diz para qual dos dois cards a
  // cliente o escolheu; ela escolhe na gaveta, onde cada card tem o rotulo do slot. Num slot so (o BBS), como sempre.
  function levarTomDaJanela(janela) {
    if (!janela || !janela.hasAttribute('data-trio-qs-tom-escolhido')) return false;
    var input = janela.querySelector('[data-trio-qs-swatch-input]:checked');
    var pid = janela.getAttribute('data-product-id');
    var selector = selectorNode();
    if (!input || input.disabled || !pid || !selector) return false;
    var variante = parseQsVariants(janela)[Number(input.value)];
    var nome = variante && variante.title ? String(variante.title).split(' / ')[0] : '';
    if (!nome) return false;
    var card = selector.querySelector('.bundle-card[data-component-product-id="' + cssEscape(pid) + '"]');
    if (!card) return false;
    if (selector.hasAttribute('data-bundle-slots') && selector.querySelectorAll('.bundle-card[data-component-product-id="' + cssEscape(pid) + '"]').length > 1) return false;
    var labels = card.querySelectorAll('label.swatch');
    var label = null;
    for (var i = 0; i < labels.length; i++) {
      if (labels[i].getAttribute('data-option-value') === nome) {
        label = labels[i];
        break;
      }
    }
    var radio = label ? label.querySelector('input') : null;
    if (!label || label.classList.contains('swatch--disabled') || !radio || radio.disabled) return false;
    if (!label.classList.contains('swatch--selected')) label.click();
    return true;
  }

  /* ================================================================ */
  /* Quick-shop (Tarefa 8): fetch do fragmento, injecao e erro/retry    */
  /* ================================================================ */

  function setStatus(texto) {
    if (statusEl) statusEl.textContent = texto || '';
  }

  // Numeral/formato/FPS vem SEMPRE do data-* do proprio gatilho clicado (kit ou
  // capitulo), nunca de uma segunda fonte: se o gatilho nao trouxer um deles a
  // linha so encolhe (sem placeholder vazio tipo "· ·").
  function eyebrowQuickShop(detail) {
    var partes = [];
    if (detail.number) partes.push(detail.number);
    if (detail.format) partes.push(detail.format);
    if (detail.fps) partes.push('FPS ' + detail.fps);
    return partes.join(' · ');
  }

  function openQuickShop(detail) {
    if (!detail || !detail.handle) return;
    var cfg = { eyebrow: eyebrowQuickShop(detail), title: 'Carregando produto...' };
    var opened = openDrawer('quickshop', { trigger: detail.trigger, cfg: cfg });
    if (!opened) return;
    loadQuickShop(detail);
  }

  // A view vem do drawer (Tarefa 13, item 5): "quick-shop" com compra avulsa, o padrao, ou
  // "quick-shop-vitrine" sem ela, o da PDP do Trio (setting do heroi).
  function viewDaJanelaQs() {
    garantirDrawer();
    var v = (drawer && drawer.getAttribute('data-trio-qs-view')) || 'quick-shop';
    return /^[a-z-]+$/.test(v) ? v : 'quick-shop';
  }

  // credentials: same-origin e SEM header Accept -- com Accept: application/json
  // o Shopify ignora o ?view= e devolve o JSON do carrinho (mesmo padrao de
  // assets/biobio-bundle-selector-trio.js e assets/biobio-kit-meter.js).
  function buscarFragmentoQs(handle, viewQs, signal, segundoPlano) {
    var opcoes = { credentials: 'same-origin' };
    if (signal) opcoes.signal = signal;
    // Rodada de correcao 1: o pedido de segundo plano leva um header proprio (same-origin, sem preflight;
    // o storefront devolve o mesmo fragmento com ele). Nao e o Accept: esse continua ausente.
    if (segundoPlano) {
      opcoes.headers = {};
      opcoes.headers[HEADER_PRE_BUSCA] = '1';
    }
    return fetch('/products/' + handle + '?view=' + viewQs, opcoes).then(function (res) {
      var ctype = (res.headers.get('Content-Type') || '').toLowerCase();
      if (!res.ok || ctype.indexOf('html') === -1) {
        throw new Error('resposta invalida (HTTP ' + res.status + ', content-type "' + ctype + '")');
      }
      return res.text();
    });
  }

  // Contrato duro: sem <html>/<body> (o template chamador tem {% layout
  // none %}) e exatamente UM marker, mesmo com status 200. Devolve o marker de
  // um documento novo a cada chamada: o cache guarda texto, nunca no, entao
  // cada abertura injeta um fragmento limpo (a marca data-trio-qs-tom-escolhido
  // nao passa de uma abertura para outra).
  function markerDoFragmento(html) {
    if (/<html[\s>]/i.test(html) || /<body[\s>]/i.test(html)) {
      throw new Error('fragmento inesperado: contem <html> ou <body>');
    }
    var dom = new DOMParser().parseFromString(html, 'text/html');
    var markers = dom.querySelectorAll('[data-trio-qs-content]');
    if (markers.length !== 1) {
      throw new Error('fragmento sem marker unico (' + markers.length + ' encontrado(s))');
    }
    return markers[0];
  }

  // Tarefa 18: o texto do fragmento pelo cache. A PROMESSA fica guardada ja na
  // hora do pedido (quem pedir de novo com o pedido em voo espera o mesmo
  // pedido, sem duplicar). O texto so resolve depois de passar pelo contrato;
  // qualquer falha (rede, status, content-type, contrato, abort) tira a
  // entrada, e a proxima busca de novo. Entrada resolvida com mais de
  // QS_VALIDADE_MS: devolve a que tem e renova uma vez em segundo plano; o texto
  // novo so entra quando chega inteiro e conferido (a abertura seguinte usa ele),
  // e uma renovacao que falha deixa a entrada antiga como estava.
  // opcoes.signal: so a pre-busca de segundo plano passa (o toque a aborta, ver
  // cederAoToque); a abertura nunca aborta o pedido do cache (esperarOuAbortar).
  // opcoes.segundoPlano: marca o pedido com o header de pre-busca.
  function chaveQs(handle, viewQs) {
    return viewQs + ' ' + handle;
  }

  function novaEntradaQs(handle, viewQs, opcoes) {
    var chave = chaveQs(handle, viewQs);
    var nova = { promessa: null, quando: 0, renovando: false, segundoPlano: !!opcoes.segundoPlano };
    nova.promessa = buscarFragmentoQs(handle, viewQs, opcoes.signal, opcoes.segundoPlano)
      .then(function (html) {
        markerDoFragmento(html);
        nova.quando = Date.now();
        return html;
      })
      .catch(function (err) {
        if (qsCache.get(chave) === nova) qsCache.delete(chave);
        throw err;
      });
    qsCache.set(chave, nova);
    return nova;
  }

  function entradaQs(handle, viewQs) {
    var entrada = qsCache.get(chaveQs(handle, viewQs));
    if (entrada && entrada.quando && !entrada.renovando && Date.now() - entrada.quando > QS_VALIDADE_MS) {
      renovarFragmentoQs(entrada, handle, viewQs);
    }
    return entrada || null;
  }

  function renovarFragmentoQs(entrada, handle, viewQs) {
    var chave = chaveQs(handle, viewQs);
    entrada.renovando = true;
    buscarFragmentoQs(handle, viewQs, null, true)
      .then(function (html) {
        markerDoFragmento(html);
        if (qsCache.get(chave) === entrada) {
          qsCache.set(chave, { promessa: Promise.resolve(html), quando: Date.now(), renovando: false, segundoPlano: true });
        }
      })
      .catch(function () {
        entrada.renovando = false;
      });
  }

  // O pedido da CLIENTE (toque e abertura). Sem entrada, abre caminho (a
  // pre-busca em voo de outro produto cede, ver cederAoToque) e conta como
  // pedido da cliente: a serie de segundo plano espera ele terminar.
  function pedirFragmentoQs(handle, viewQs) {
    var entrada = entradaQs(handle, viewQs);
    if (entrada) return entrada.promessa;
    if (viewQs === VIEW_VITRINE) cederAoToque(handle);
    var nova = novaEntradaQs(handle, viewQs, {});
    preBusca.daCliente += 1;
    var fim = function () {
      preBusca.daCliente -= 1;
      proximaPreBusca();
    };
    nova.promessa.then(fim, fim);
    return nova.promessa;
  }

  // A abertura espera a promessa do cache mas para de esperar no abort dela
  // (outro produto, troca de modo, drawer fechado: releaseView), com o mesmo
  // AbortError de antes; o pedido compartilhado segue e serve a proxima
  // abertura.
  function esperarOuAbortar(promessa, signal) {
    return new Promise(function (resolve, reject) {
      function aoAbortar() {
        var err = new Error('abertura da janela abandonada');
        err.name = 'AbortError';
        reject(err);
      }
      if (signal.aborted) {
        aoAbortar();
        return;
      }
      signal.addEventListener('abort', aoAbortar);
      promessa.then(
        function (html) {
          signal.removeEventListener('abort', aoAbortar);
          resolve(html);
        },
        function (err) {
          signal.removeEventListener('abort', aoAbortar);
          reject(err);
        }
      );
    });
  }

  // Tarefa 18: economia de dados declarada pelo navegador. Sem
  // navigator.connection (Safari, Firefox) nao ha como saber: pre-busca.
  function economiaDeDados() {
    var c = navigator.connection;
    if (!c) return false;
    return !!c.saveData || c.effectiveType === 'slow-2g' || c.effectiveType === '2g';
  }

  /* ---------------------------------------------------------------- */
  /* Pre-busca de segundo plano (Tarefa 18 e rodada de correcao 1)     */
  /* ---------------------------------------------------------------- */

  // UMA busca de segundo plano por produto com gatilho de janela (Base, BBS, Po
  // Facial, pelos handles dos proprios gatilhos), um pedido por vez, e nenhum
  // enquanto houver pedido da cliente em curso. A serie comeca depois do load
  // (agendarPreBuscaJanelas) e vai do gatilho mais perto da tela ao mais longe
  // (distancia do centro do gatilho ao centro da tela). O IntersectionObserver
  // dos gatilhos (margem de uma tela acima e abaixo) adianta o produto que se
  // aproxima: nada em voo, busca na hora; algo em voo, e o proximo da fila. O
  // produto buscado com o gatilho perto (dentro da margem) tem tambem a
  // primeira foto da janela aquecida (aquecerFoto); o buscado longe, na serie
  // ociosa, nunca. Com economia de dados nada disto roda. Todo pedido daqui leva
  // o header X-Trio-Pre-Busca: 1 (o harness aborta esse pedido por padrao).
  //   ativa: serie liberada (depois do load, sem economia de dados).
  //   fila: handles na ordem em que vao sair.
  //   emVoo: { handle, ctrl, entrada, cedido } do pedido de segundo plano em curso.
  //   daCliente: pedidos da cliente (toque, abertura) em curso.
  //   feito: produto que ja teve a busca de segundo plano terminada (com ou sem
  //     falha): nao volta, o toque busca se precisar.
  //   perto: Map gatilho -> dentro da margem do observador.
  //   fotos: produto -> Image() ja criado (referencia viva ate o fim da pagina).
  var HEADER_PRE_BUSCA = 'X-Trio-Pre-Busca';
  var preBusca = { ativa: false, fila: [], emVoo: null, daCliente: 0, feito: {}, perto: new Map(), fotos: {}, observador: null };

  function handleEstaPerto(h) {
    var sim = false;
    preBusca.perto.forEach(function (dentro, el) {
      if (dentro && el.getAttribute('data-handle') === h) sim = true;
    });
    return sim;
  }

  function proximaPreBusca() {
    if (!preBusca.ativa || preBusca.emVoo || preBusca.daCliente > 0) return;
    while (preBusca.fila.length) {
      var h = preBusca.fila.shift();
      if (preBusca.feito[h] || qsCache.has(chaveQs(h, VIEW_VITRINE))) continue;
      buscarEmSegundoPlano(h);
      return;
    }
  }

  function buscarEmSegundoPlano(h) {
    var ctrl = typeof AbortController === 'function' ? new AbortController() : null;
    var voo = { handle: h, ctrl: ctrl, entrada: null, cedido: false };
    preBusca.emVoo = voo;
    voo.entrada = novaEntradaQs(h, VIEW_VITRINE, { signal: ctrl ? ctrl.signal : null, segundoPlano: true });
    voo.entrada.promessa.then(
      function (html) {
        if (voo.cedido) return;
        preBusca.emVoo = null;
        preBusca.feito[h] = true;
        if (handleEstaPerto(h)) aquecerFoto(h, html);
        proximaPreBusca();
      },
      function () {
        // Cedido ao toque: cederAoToque ja devolveu o produto para a fila.
        if (voo.cedido) return;
        preBusca.emVoo = null;
        preBusca.feito[h] = true;
        proximaPreBusca();
      }
    );
  }

  // Rodada de correcao 1 (prioridade do toque): a cliente pediu um produto
  // ainda sem cache e a pre-busca em voo e de OUTRO. Ela e abortada, sai do
  // cache na hora (nao fica como falha nem serve uma abertura com a promessa
  // abortada) e volta para a frente da fila; o pedido da cliente sai sem
  // dividir a banda com ela. Pre-busca do proprio produto: pedirFragmentoQs ja
  // devolve a mesma promessa. Uma janela esperando a pre-busca em voo
  // (qsCarregando) nunca perde o pedido dela.
  function cederAoToque(h) {
    var voo = preBusca.emVoo;
    if (!voo || voo.handle === h || !voo.ctrl || voo.handle === qsCarregando) return;
    voo.cedido = true;
    preBusca.emVoo = null;
    var chave = chaveQs(voo.handle, VIEW_VITRINE);
    if (qsCache.get(chave) === voo.entrada) qsCache.delete(chave);
    preBusca.fila.unshift(voo.handle);
    voo.ctrl.abort();
  }

  // Primeira foto da janela, com o mesmo srcset e sizes da img do fragmento: o
  // navegador escolhe a mesma candidata e a janela a encontra pronta. Uma vez por
  // produto, nunca com economia de dados.
  function aquecerFoto(h, html) {
    if (preBusca.fotos[h] || economiaDeDados()) return;
    var img = null;
    try {
      img = markerDoFragmento(html).querySelector('[data-trio-qs-media]');
    } catch (e) {
      return;
    }
    var src = img && img.getAttribute('src');
    if (!src) return;
    var foto = new Image();
    foto.decoding = 'async';
    if (img.getAttribute('sizes')) foto.sizes = img.getAttribute('sizes');
    if (img.getAttribute('srcset')) foto.srcset = img.getAttribute('srcset');
    foto.src = src;
    preBusca.fotos[h] = foto;
  }

  // O gatilho de h entrou na margem do observador. Antes de a serie comecar
  // (antes do load) so fica registrado: a ordem da serie ja comeca por ele.
  function aproximou(h) {
    if (!preBusca.ativa) return;
    var entrada = qsCache.get(chaveQs(h, VIEW_VITRINE));
    if (entrada) {
      // Ja buscado (ou em voo) em segundo plano: aquece a foto quando o texto
      // estiver aqui. Buscado pela cliente: a janela ja abriu e pediu a foto.
      if (entrada.segundoPlano) {
        entrada.promessa.then(function (html) {
          if (handleEstaPerto(h)) aquecerFoto(h, html);
        }, function () {});
      }
      return;
    }
    if (preBusca.feito[h]) return;
    var i = preBusca.fila.indexOf(h);
    if (i !== -1) preBusca.fila.splice(i, 1);
    preBusca.fila.unshift(h);
    proximaPreBusca();
  }

  function observarGatilhos() {
    if (preBusca.observador || typeof window.IntersectionObserver !== 'function') return;
    if (viewDaJanelaQs() !== VIEW_VITRINE) return;
    var gatilhos = document.querySelectorAll('[data-trio-quickshop-trigger][data-handle]');
    if (!gatilhos.length) return;
    preBusca.observador = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        var antes = !!preBusca.perto.get(e.target);
        preBusca.perto.set(e.target, e.isIntersecting);
        if (e.isIntersecting && !antes) aproximou(e.target.getAttribute('data-handle'));
      });
    }, { rootMargin: '100% 0px 100% 0px' });
    gatilhos.forEach(function (el) {
      preBusca.observador.observe(el);
    });
  }

  // Comeco da serie: handles sem repetir, do gatilho mais perto do centro da
  // tela ao mais longe (gatilho sem caixa, escondido, por ultimo).
  function iniciarPreBusca() {
    if (preBusca.ativa || viewDaJanelaQs() !== VIEW_VITRINE || economiaDeDados()) return;
    preBusca.ativa = true;
    var meio = (window.innerHeight || document.documentElement.clientHeight || 0) / 2;
    var dist = {};
    var handles = [];
    document.querySelectorAll('[data-trio-quickshop-trigger][data-handle]').forEach(function (el) {
      var h = el.getAttribute('data-handle');
      if (!h) return;
      var r = el.getBoundingClientRect();
      var d = r.width || r.height ? Math.abs(r.top + r.height / 2 - meio) : Infinity;
      if (!(h in dist)) {
        dist[h] = d;
        handles.push(h);
      } else if (d < dist[h]) {
        dist[h] = d;
      }
    });
    handles.sort(function (a, b) {
      return dist[a] - dist[b];
    });
    preBusca.fila = handles;
    proximaPreBusca();
  }

  // Depois do load (nenhum pedido compete com a carga da pagina), em idle, com
  // teto de 2 s; sem requestIdleCallback (Safari), setTimeout de 2 s. Uma vez so.
  function agendarPreBuscaJanelas() {
    if (preBuscaAgendada) return;
    preBuscaAgendada = true;
    observarGatilhos();
    function depoisDoLoad() {
      if (typeof window.requestIdleCallback === 'function') {
        window.requestIdleCallback(iniciarPreBusca, { timeout: 2000 });
      } else {
        setTimeout(iniciarPreBusca, 2000);
      }
    }
    if (document.readyState === 'complete') depoisDoLoad();
    else window.addEventListener('load', depoisDoLoad, { once: true });
  }

  // Tarefa 18: o dedo encostou num gatilho de janela. Em qualquer rede (e um
  // gesto da cliente, nao segundo plano), a busca comeca aqui, os 100 a 300 ms
  // antes do click, passando na frente da pre-busca de outro produto.
  // Passivo: nao segura a rolagem que comeca em cima do gatilho.
  function preBuscarNoToque(event) {
    var alvo = event.target && event.target.closest ? event.target.closest('[data-trio-quickshop-trigger]') : null;
    if (!alvo) return;
    var h = alvo.getAttribute('data-handle');
    if (!h || viewDaJanelaQs() !== VIEW_VITRINE) return;
    pedirFragmentoQs(h, VIEW_VITRINE).catch(function () {});
  }

  function loadQuickShop(detail) {
    var view = views.quickshop;
    if (!view) return;

    // Token de sequencia: se outra selecao (outro produto) chegar antes desta
    // resposta, esta resposta e descartada mesmo que o fetch nao tenha sido
    // abortado a tempo (rede lenta, resposta ja em transito).
    var seq = ++qsSeq;
    if (qsAbort) qsAbort.abort();
    qsAbort = new AbortController();

    view.innerHTML = '';
    view.setAttribute('aria-busy', 'true');
    setStatus('Carregando produto...');

    // Tarefa 18: na view sem compra (a desta PDP) o texto vem do cache. Ja
    // resolvido, os then abaixo rodam como microtarefa da mesma tarefa do
    // toque, antes do proximo quadro: o "Carregando produto..." nao chega a ser
    // pintado. Em voo (pre-busca ou pointerdown), espera o mesmo pedido. Na view
    // com compra, sem cache: o fetch abortavel de sempre.
    var viewDaJanela = viewDaJanelaQs();
    var sinal = qsAbort.signal;
    var pedido;
    if (viewDaJanela === VIEW_VITRINE) {
      // Rodada de correcao 1: esperando uma pre-busca de segundo plano que falhou (rede, ou o harness, que
      // aborta esse pedido por padrao), a janela tenta uma vez como pedido da cliente antes de mostrar o
      // erro: a falha do segundo plano nao e da cliente.
      var antes = qsCache.get(chaveQs(detail.handle, viewDaJanela));
      var esperaSegundoPlano = !!(antes && antes.segundoPlano && !antes.quando);
      var handleDaJanela = detail.handle;
      qsCarregando = handleDaJanela;
      pedido = esperarOuAbortar(pedirFragmentoQs(handleDaJanela, viewDaJanela), sinal)
        .catch(function (err) {
          if (!esperaSegundoPlano || sinal.aborted) throw err;
          return esperarOuAbortar(pedirFragmentoQs(handleDaJanela, viewDaJanela), sinal);
        })
        .then(
          function (html) {
            if (seq === qsSeq) qsCarregando = null;
            return html;
          },
          function (err) {
            if (seq === qsSeq) qsCarregando = null;
            throw err;
          }
        );
    } else {
      pedido = buscarFragmentoQs(detail.handle, viewDaJanela, sinal);
    }
    pedido
      .then(function (html) {
        if (seq !== qsSeq) return; // selecao mudou enquanto isto estava a caminho

        var marker = markerDoFragmento(html);
        view.innerHTML = '';
        view.appendChild(marker);
        view.removeAttribute('aria-busy');
        setStatus('');

        var nomeEl = view.querySelector('[data-trio-qs-name]');
        if (titleEl && nomeEl && nomeEl.textContent.trim()) {
          var nomeReal = nomeEl.textContent.trim();
          titleEl.textContent = nomeReal;
          // Tarefa 9: currentCfg.title tambem precisa do nome real, senao um
          // push pra pilha local (gatilho "Nao sabe seu tom?" -> finder)
          // captura o cfg com o titulo placeholder "Carregando produto...",
          // e Voltar restaura esse placeholder por cima do nome real ja
          // visivel. Mutar o MESMO objeto de currentCfg (nunca MODES.bundle/
          // MODES.finder, que sao estaticos e nunca viram currentCfg aqui):
          // este cfg foi criado como objeto literal novo em openQuickShop,
          // exclusivo desta abertura.
          if (currentCfg && openMode === 'quickshop') currentCfg.title = nomeReal;
        }
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        if (seq !== qsSeq) return;
        console.error('[trio] quick-shop falhou', err);
        view.removeAttribute('aria-busy');
        setStatus('');
        renderQuickShopError(view, detail);
      });
  }

  // Erro acessivel: role="alert" anuncia sozinho (independe do aria-live do
  // status do cabecalho), retry re-busca o MESMO produto, e o link degrada pra
  // navegacao real com o href que o gatilho ja tinha (funcional sem JS).
  function renderQuickShopError(view, detail) {
    view.innerHTML = '';
    var href = (detail.trigger && detail.trigger.getAttribute('href')) || '/products/' + detail.handle;

    var wrap = document.createElement('div');
    wrap.className = 'trio-qs__error';
    wrap.setAttribute('role', 'alert');

    var msg = document.createElement('p');
    msg.className = 'trio-qs__error-msg';
    msg.textContent = 'Não foi possível carregar este produto agora.';

    var retry = document.createElement('button');
    retry.type = 'button';
    retry.className = 'trio-cta trio-qs__error-retry';
    retry.textContent = 'Tentar de novo';
    retry.addEventListener('click', function () {
      loadQuickShop(detail);
    });

    var link = document.createElement('a');
    link.className = 'trio-qs__pdp-link';
    link.href = href;
    link.textContent = 'Ver na página do produto';

    wrap.appendChild(msg);
    wrap.appendChild(retry);
    wrap.appendChild(link);
    view.appendChild(wrap);
    retry.focus();
  }

  /* ================================================================ */
  /* Quick-shop (Tarefa 8): leitura do JSON inline e aplicacao atomica  */
  /* ================================================================ */

  // Sem estado de modulo (nada de cache entre aberturas): sempre re-le o JSON
  // do proprio `root` no momento do evento. (O cache da Tarefa 18 guarda so o
  // texto do fragmento; cada abertura injeta um documento novo, com o proprio
  // JSON.) Registrar listeners por instancia
  // em vez de delegar acumularia handler a cada produto aberto em sequencia
  // (o `view` da casca e reaproveitado, nunca recriado) -- e cada handler
  // velho leria um `byId` de um produto diferente do que esta na tela.
  function parseQsVariants(root) {
    var dataEl = root && root.querySelector('[data-trio-qs-variants]');
    if (!dataEl) return {};
    try {
      var lista = JSON.parse(dataEl.textContent);
      var byId = {};
      lista.forEach(function (v) {
        byId[v.id] = v;
      });
      return byId;
    } catch (err) {
      console.error('[trio] JSON de variantes do quick-shop invalido', err);
      return {};
    }
  }

  function capitalizar(s) {
    if (!s) return '';
    return s.charAt(0).toUpperCase() + s.slice(1);
  }

  // Atomico: disponibilidade, midia, copy, preco, desconto e CTA mudam juntos
  // numa unica passada de DOM, nunca em etapas que a cliente veria pela metade.
  function applyQsVariant(root, v) {
    if (!root || !v) return;

    var addBtn = root.querySelector('[data-trio-qs-add]');
    var addLabel = root.querySelector('[data-trio-qs-add-label]');
    var priceCurrent = root.querySelector('[data-trio-qs-current]');
    var priceCompare = root.querySelector('[data-trio-qs-compare]');
    var pricePct = root.querySelector('[data-trio-qs-pct]');
    var variantName = root.querySelector('[data-trio-qs-variant-name]');
    var variantMeta = root.querySelector('[data-trio-qs-variant-meta]');
    var variantFull = root.querySelector('[data-trio-qs-variant-full]');
    var mediaImg = root.querySelector('[data-trio-qs-media]');

    if (addBtn) {
      addBtn.dataset.variantId = v.id;
      addBtn.disabled = !v.available;
    }
    if (addLabel) addLabel.textContent = v.available ? 'Adicionar ao carrinho' : 'Esgotado';

    if (priceCurrent) {
      priceCurrent.innerHTML = '<span class="visually-hidden">Por </span>' + v.priceHtml;
    }
    if (priceCompare) {
      var temCompare = v.compareAtPrice > v.price;
      priceCompare.hidden = !temCompare;
      if (temCompare) {
        priceCompare.innerHTML = '<span class="visually-hidden">De </span><s>' + v.compareAtPriceHtml + '</s>';
      }
    }
    if (pricePct) {
      var temPct = v.discountPct > 0;
      pricePct.hidden = !temPct;
      if (temPct) pricePct.textContent = '-' + v.discountPct + '%';
    }

    if (variantName) variantName.textContent = v.title;
    if (variantMeta) {
      var partesMeta = [];
      if (v.profundidade) partesMeta.push(capitalizar(v.profundidade));
      if (v.subtom) partesMeta.push('subtom ' + v.subtom);
      variantMeta.hidden = partesMeta.length === 0;
      variantMeta.textContent = partesMeta.join(' · ');
    }
    if (variantFull) {
      variantFull.hidden = !v.descricaoTom;
      variantFull.textContent = v.descricaoTom || '';
    }

    // srcset ANTES do src (Tarefa 11.1): com o src primeiro, o navegador escolhia de novo no srcset
    // antigo, pedia outra vez a foto do tom anterior e cancelava esse pedido quando o srcset novo
    // chegava (um net::ERR_ABORTED a cada troca de tom, medido pelo quickshopTrocaTomSemAborto).
    if (mediaImg && v.imageUrl) {
      mediaImg.srcset = v.imageSrcset || v.imageUrl;
      mediaImg.src = v.imageUrl;
      if (v.imageAlt) mediaImg.alt = v.imageAlt;
    }
  }

  /* ================================================================ */
  /* Galeria da primeira tela (PDP v2, Tarefa 8): scroll-snap nativo com  */
  /* fatia da foto seguinte (padrao Rhode). Sem bolinhas: fio de          */
  /* progresso + regiao viva, sincronizados por IntersectionObserver.     */
  /* O slide do video (posicao do setting video_posicao, 3 hoje) e so o   */
  /* poster com um botao de play, e o slide 1 tem o atalho do canto; o    */
  /* toque em qualquer um dos dois abre o lightbox vertical abaixo.       */
  /* Sem swiper.                                                          */
  /* ================================================================ */

  // Lightbox do video (fix round 2 da Tarefa 8, decisao do Breno): <dialog> nativo filho
  // direto do <body>, porque no iOS um position:fixed dentro do trilho com scroll-snap e
  // tratado como estatico. showModal() da o top layer, o Esc (evento cancel) e o inert do
  // resto da pagina. O <video> so e criado aqui, no toque: nenhum MP4 baixa antes.
  //
  // Tarefa 13 (item 2, decisoes do Breno de 25/09, depois do teste no iPhone):
  // - abre COM SOM: o toque que abriu e o gesto da cliente (nada toca com som sem toque). Se o
  //   navegador recusar mesmo assim (iOS sem gesto na pilha, como no toque repetido pela fila de antes
  //   do boot), toca mudo e o botao de som diz "Ativar som": nunca afirma um som que nao ha;
  // - abre tambem a partir do video dos blocos e dos cartoes do carrossel (o botao
  //   [data-trio-video-abrir] por cima de cada video), com AQUELE video, do ponto em que ele estava; o
  //   video da pagina fica parado enquanto a tela cheia esta aberta e volta a tocar (mudo, do ponto
  //   onde a tela cheia parou) quando ela fecha, se estava tocando;
  // - os controles da pagina ficam numa FAIXA ACIMA do video (som a esquerda, fechar a direita), e o
  //   video e dimensionado para caber abaixo dela (assets/biobio-trio.css): no iPhone o X ficava em
  //   cima do controle nativo de som do Safari, no canto de cima do video.
  var lightbox = null;
  var lightboxGatilho = null;
  var lightboxVideo = null;
  var lightboxOrigem = null;
  var lightboxOrigemTocava = false;

  // Icones do botao de som: os mesmos do botao de som dos blocos (sections/biobio-trio-bloco.liquid).
  var ICONE_SOM_DESLIGADO =
    '<svg class="trio-lightbox__icon-off" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/><line x1="23" y1="9" x2="17" y2="15"/><line x1="17" y1="9" x2="23" y2="15"/></svg>';
  var ICONE_SOM_LIGADO =
    '<svg class="trio-lightbox__icon-on" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/><path d="M15.54 8.46a5 5 0 0 1 0 7.07"/><path d="M19.07 4.93a10 10 0 0 1 0 14.14"/></svg>';

  function fecharLightbox() {
    if (!lightbox || !lightbox.open) return;
    lightbox.close();
  }

  // O botao de som da faixa espelha o video do lightbox, venha a mudanca de onde vier (o proprio
  // botao, os controles nativos, o recuo para mudo). Mesmo contrato do botao de som da pagina
  // (sincronizarSom): o rotulo diz a acao, sem aria-pressed, e o estado visual e a classe is-on.
  function sincronizarSomDoLightbox() {
    if (!lightbox) return;
    var botao = lightbox.querySelector('[data-trio-lightbox-som]');
    if (!botao) return;
    var ligado = !!(lightboxVideo && !lightboxVideo.muted && lightboxVideo.volume > 0);
    botao.removeAttribute('aria-pressed');
    botao.setAttribute('aria-label', ligado ? 'Desativar som' : 'Ativar som');
    botao.classList.toggle('is-on', ligado);
  }

  // Toque no botao de som: e gesto da cliente, entao desmutar e permitido ate no iOS. Volume zerado
  // pelos controles nativos conta como sem som; ligar devolve o volume.
  function alternarSomDoLightbox() {
    var v = lightboxVideo;
    if (!v) return;
    var ligado = !v.muted && v.volume > 0;
    if (ligado) {
      v.muted = true;
    } else {
      v.muted = false;
      if (v.volume === 0) v.volume = 1;
    }
    sincronizarSomDoLightbox();
  }

  function garantirLightbox() {
    if (lightbox && lightbox.isConnected) return lightbox;
    var d = document.createElement('dialog');
    d.className = 'biobio-trio trio-lightbox';
    // Nome inicial do dialogo: o data-nome do gatilho da galeria (setting video_galeria_nome do
    // heroi). abrirLightbox() troca pelo nome de cada fonte na hora de abrir.
    var gatilhoDaGaleria = document.querySelector('[data-trio-gallery-play][data-nome], [data-trio-gallery-atalho][data-nome]');
    d.setAttribute('aria-label', (gatilhoDaGaleria && gatilhoDaGaleria.getAttribute('data-nome')) || 'Vídeo da Lua');
    d.innerHTML =
      '<div class="trio-lightbox__barra" data-trio-lightbox-barra>' +
      '<button type="button" class="trio-lightbox__ctrl trio-lightbox__som is-on" data-trio-lightbox-som aria-label="Desativar som">' +
      ICONE_SOM_DESLIGADO +
      ICONE_SOM_LIGADO +
      '</button>' +
      '<button type="button" class="trio-lightbox__ctrl trio-lightbox__close" data-trio-lightbox-close aria-label="Fechar vídeo">' +
      '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" fill="none"/></svg>' +
      '</button>' +
      '</div>' +
      '<div class="trio-lightbox__frame" data-trio-lightbox-frame></div>';
    document.body.appendChild(d);
    d.addEventListener('click', function (event) {
      var alvo = event.target;
      if (alvo.closest('[data-trio-lightbox-som]')) {
        alternarSomDoLightbox();
        return;
      }
      // Fecha no botao ou no FUNDO: o fundo e o proprio <dialog>, o frame (o video e dimensionado
      // pela proporcao, entao as faixas pretas em volta dele sao do frame, nao do video) ou a faixa de
      // cima fora dos dois botoes. Toque no video (e nos controles nativos dele) nao fecha.
      // Revisao da T8, N1: antes so `event.target === d` contava, e o frame cobria o dialog
      // inteiro, entao o toque no preto nunca fechava.
      if (
        alvo.closest('[data-trio-lightbox-close]') ||
        alvo === d ||
        alvo.hasAttribute('data-trio-lightbox-frame') ||
        alvo.hasAttribute('data-trio-lightbox-barra')
      ) {
        fecharLightbox();
      }
    });
    d.addEventListener('close', function () {
      var frame = d.querySelector('[data-trio-lightbox-frame]');
      var v = frame.querySelector('video');
      // Ponto em que a tela cheia parou, lido ANTES de descarregar (o load() zera o tempo).
      var fim = v && isFinite(v.currentTime) ? v.currentTime : 0;
      if (v) {
        v.pause();
        v.removeAttribute('src');
        v.load();
      }
      frame.textContent = '';
      lightboxVideo = null;
      // Tarefa 11.1 (I1 da revisao final): o lightbox fechado porque o drawer abriu (openDrawer ->
      // fecharLightbox) chega aqui com o drawer ja aberto. A trava de rolagem e o foco passam a ser
      // do drawer: tirar a classe soltaria o fundo com o drawer na tela, e devolver o foco ao
      // gatilho (atras do drawer, inert) tiraria o foco do dialogo.
      if (!openMode) {
        document.documentElement.classList.remove('biobio-trio-noscroll');
        document.body.classList.remove('biobio-trio-noscroll');
        if (lightboxGatilho && lightboxGatilho.isConnected) lightboxGatilho.focus();
      }
      // Tarefa 13: o video da pagina que abriu a tela cheia segue do ponto onde ela parou e, se estava
      // tocando, volta a tocar (mudo: a tela cheia silenciou a pagina ao abrir). Nao volta com o drawer
      // na frente nem se a cliente o tinha pausado.
      var origem = lightboxOrigem;
      var tocava = lightboxOrigemTocava;
      lightboxOrigem = null;
      lightboxOrigemTocava = false;
      if (origem) origem.removeAttribute('data-trio-em-tela-cheia');
      if (origem && origem.isConnected) {
        if (origem.getAttribute('src') && fim > 0.5 && (!origem.duration || fim < origem.duration)) {
          try {
            origem.currentTime = fim;
          } catch (e) {
            /* o video da pagina ainda sem dados: segue de onde estava */
          }
        }
        if (tocava && !openMode && !reduceMotion() && !origem.dataset.userPaused) {
          var retomada = origem.play();
          if (retomada && typeof retomada.catch === 'function') {
            retomada.catch(function () {
              sincronizarPlay(origem);
            });
          }
        }
      }
      lightboxGatilho = null;
    });
    lightbox = d;
    return d;
  }

  // De onde vem o video do lightbox. Os gatilhos da galeria trazem data-src, data-poster, data-alt e
  // data-nome (o nome do dialogo, setting video_galeria_nome do heroi; sem ele, o data-alt). O
  // botao de tela cheia dos blocos e dos cartoes ([data-trio-video-abrir], Tarefa 13) usa o video do
  // proprio quadro: o MP4 do data-src (o mesmo 1080p do lightbox da galeria; o HLS dos blocos no
  // celular e para o video pequeno da pagina), o poster e o texto acessivel dele, que tambem vira o
  // nome do dialogo (o dos blocos 1, 2, 4 e 5 e da Lua, o do bloco 3 e dos cartoes nao), e o tempo em
  // que ele estava.
  function fonteDoLightbox(gatilho) {
    if (gatilho.hasAttribute('data-trio-video-abrir')) {
      var quadro = gatilho.closest('[data-trio-video-frame]');
      var video = quadro ? quadro.querySelector(VIDEO_LAZY) : null;
      if (!video || !video.dataset.src) return null;
      var texto = video.getAttribute('aria-label') || '';
      return {
        src: video.dataset.src,
        poster: video.getAttribute('poster') || video.getAttribute('data-poster') || '',
        alt: texto,
        nome: texto || 'Vídeo',
        origem: video,
        inicio: video.getAttribute('src') && isFinite(video.currentTime) ? video.currentTime : 0,
      };
    }
    var src = gatilho.getAttribute('data-src');
    if (!src) return null;
    return {
      src: src,
      poster: gatilho.getAttribute('data-poster') || '',
      alt: gatilho.getAttribute('data-alt') || '',
      nome: gatilho.getAttribute('data-nome') || gatilho.getAttribute('data-alt') || 'Vídeo',
      origem: null,
      inicio: 0,
    };
  }

  function abrirLightbox(gatilho) {
    var fonte = fonteDoLightbox(gatilho);
    if (!fonte) return;
    // Sem <dialog> modal (navegador antigo): nada de trava de rolagem nem de dialog aberto por
    // atributo, que nunca fecharia (revisao da T8, N6). O MP4 abre numa aba; se o navegador
    // bloquear a aba, abre na propria pagina. O video continua acessivel.
    if (typeof HTMLDialogElement !== 'function' || typeof document.createElement('dialog').showModal !== 'function') {
      var aba = window.open(fonte.src, '_blank', 'noopener');
      if (!aba) window.location.assign(fonte.src);
      return;
    }
    var d = garantirLightbox();
    // Ja aberto (dois toques enfileirados antes do boot, atalho e play): showModal() num dialog
    // aberto lanca InvalidStateError. O primeiro toque ja fez o trabalho.
    if (d.open) return;
    // Um modal por vez (Tarefa 11.1, I1 da revisao final): abrir o lightbox fecha o drawer, sem
    // devolver o foco ao gatilho dele (o foco vai para o fechar do lightbox, logo abaixo). O
    // closeDrawer solta a trava e o inert; a trava volta abaixo, agora do lightbox.
    if (openMode) closeDrawer({ restoreFocus: false });
    // Som exclusivo tambem com o modal (revisao da T9, M2): um video de bloco ou do trilho que
    // estivesse tocando com som seguia audivel atras do lightbox. Silencia (o botao de som
    // acompanha); o video continua tocando mudo, como qualquer video em vista, menos o que abriu a
    // tela cheia, que para enquanto ela estiver aberta (Tarefa 13).
    silenciarVideos();
    lightboxOrigem = fonte.origem;
    lightboxOrigemTocava = !!(fonte.origem && !fonte.origem.paused);
    if (fonte.origem) {
      // Marca para o observador do autoplay nao retomar o video atras da tela cheia.
      fonte.origem.setAttribute('data-trio-em-tela-cheia', '');
      if (!fonte.origem.paused) fonte.origem.pause();
    }
    d.setAttribute('aria-label', fonte.nome);
    var frame = d.querySelector('[data-trio-lightbox-frame]');
    var v = document.createElement('video');
    v.className = 'trio-lightbox__video';
    // Com som (Tarefa 13): o toque que abriu e o gesto da cliente. Sem o atributo muted.
    v.muted = false;
    v.setAttribute('playsinline', '');
    v.setAttribute('controls', '');
    v.setAttribute('preload', 'auto');
    if (fonte.poster) v.setAttribute('poster', fonte.poster);
    if (fonte.alt) v.setAttribute('aria-label', fonte.alt);
    // Sem autoplay sob prefers-reduced-motion: abre parado, com os controles nativos, e o play da
    // cliente ja sai com som.
    if (!reduceMotion()) v.setAttribute('autoplay', '');
    v.addEventListener('volumechange', sincronizarSomDoLightbox);
    v.src = fonte.src;
    // Continua do ponto em que o video da pagina estava: antes dos dados, o navegador guarda o tempo
    // como posicao inicial; o loadedmetadata garante, para quem nao guarda.
    if (fonte.inicio > 0.5) {
      var inicio = fonte.inicio;
      try {
        v.currentTime = inicio;
      } catch (e) {
        /* aplicado no loadedmetadata */
      }
      v.addEventListener(
        'loadedmetadata',
        function () {
          if (v.currentTime < inicio - 0.5 && (!v.duration || inicio < v.duration)) v.currentTime = inicio;
        },
        { once: true }
      );
    }
    frame.textContent = '';
    frame.appendChild(v);
    lightboxVideo = v;
    lightboxGatilho = gatilho;
    sincronizarSomDoLightbox();
    document.documentElement.classList.add('biobio-trio-noscroll');
    document.body.classList.add('biobio-trio-noscroll');
    d.showModal();
    var fechar = d.querySelector('[data-trio-lightbox-close]');
    if (fechar) fechar.focus();
    if (!reduceMotion()) {
      var p = v.play();
      if (p && p.catch) {
        p.catch(function (erro) {
          // Navegador que nao deixa tocar com som sem gesto na pilha: toca mudo e o botao diz
          // "Ativar som". Outra recusa (fechou antes de comecar, fonte com erro) nao insiste.
          if (!erro || erro.name !== 'NotAllowedError' || lightboxVideo !== v || !d.open) return;
          v.muted = true;
          sincronizarSomDoLightbox();
          var mudo = v.play();
          if (mudo && mudo.catch) mudo.catch(function () {});
        });
      }
    }
  }

  if (window.customElements && !customElements.get('trio-gallery')) {
    customElements.define('trio-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this._pronto) return;
        this._pronto = true;
        var track = this.querySelector('[data-trio-gallery-track]');
        var slides = Array.prototype.slice.call(this.querySelectorAll('[data-trio-gallery-slide]'));
        var fill = this.querySelector('[data-trio-gallery-progress]');
        var status = this.querySelector('[data-trio-gallery-status]');
        var self = this;
        var atual = 0;

        // Fio de progresso + regiao viva no lugar das bolinhas (fix round 3): o
        // preenchimento ja nasce com 100/total por cento de largura no Liquid, entao aqui so
        // desloca em multiplos da propria largura. O texto diz "Foto N de T" (ou "Vídeo N de
        // T" no slide do trecho da Lua), que e o que as bolinhas nunca diziam.
        var prev = this.querySelector('[data-trio-gallery-prev]');
        var next = this.querySelector('[data-trio-gallery-next]');

        // Setas de desktop: aria-disabled nos extremos (o botao segue focavel, sem perder o foco).
        function sincronizarSetas() {
          if (prev) {
            if (atual === 0) prev.setAttribute('aria-disabled', 'true'); else prev.removeAttribute('aria-disabled');
          }
          if (next) {
            if (atual === slides.length - 1) next.setAttribute('aria-disabled', 'true'); else next.removeAttribute('aria-disabled');
          }
        }

        function marcar(i) {
          if (i < 0 || i === atual) return;
          atual = i;
          sincronizarSetas();
          if (fill) fill.style.transform = 'translateX(' + i * 100 + '%)';
          if (status) {
            var tipo = slides[i] && slides[i].hasAttribute('data-trio-gallery-video') ? 'Vídeo' : 'Foto';
            status.textContent = tipo + ' ' + (i + 1) + ' de ' + slides.length;
          }
        }

        // Durante uma rolagem programada (seta, teclado, pulo ao tom) o IntersectionObserver ve
        // slides intermediarios a 0,6 e reescreveria `atual`, desfazendo a marcacao e fazendo
        // cliques rapidos partirem do indice errado. Entao so o slide alvo e aceito; o alvo e
        // liberado ao chegar, no `scrollend` ou por tempo (com `auto` o IO pode nem disparar).
        var alvoRolagem = -1;
        var timerRolagem = null;
        function liberarRolagem() {
          alvoRolagem = -1;
          if (timerRolagem !== null) { clearTimeout(timerRolagem); timerRolagem = null; }
        }
        // Slide de fato alinhado ao trilho: o de borda esquerda mais perto da borda do trilho somada ao padding.
        function slideAlinhado() {
          var borda = track.getBoundingClientRect().left + (parseFloat(window.getComputedStyle(track).paddingLeft) || 0);
          var melhor = -1;
          var menor = Infinity;
          for (var k = 0; k < slides.length; k++) {
            var d = Math.abs(slides[k].getBoundingClientRect().left - borda);
            if (d < menor) { menor = d; melhor = k; }
          }
          return melhor;
        }
        // Guarda liberada pelo `scrollend` ou pelo tempo, e não pelo IO no alvo: um swipe feito dentro da janela
        // teve o cruzamento ignorado, então marca o slide alinhado (sem isso status e setas ficavam um slide atrás).
        function liberarESincronizar() {
          if (alvoRolagem === -1) return;
          liberarRolagem();
          marcar(slideAlinhado());
        }
        if (track) track.addEventListener('scrollend', liberarESincronizar);

        function irPara(slide) {
          if (!track || !slide) return;
          alvoRolagem = slides.indexOf(slide);
          if (timerRolagem !== null) clearTimeout(timerRolagem);
          timerRolagem = setTimeout(liberarESincronizar, 1000);
          track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: reduceMotion() ? 'auto' : 'smooth' });
        }

        if ('IntersectionObserver' in window && track) {
          this._io = new IntersectionObserver(function (entries) {
            entries.forEach(function (e) {
              if (!e.isIntersecting || e.intersectionRatio < 0.6) return;
              var idx = slides.indexOf(e.target);
              if (alvoRolagem !== -1) {
                if (idx !== alvoRolagem) return;
                liberarRolagem();
              }
              marcar(idx);
            });
          }, { root: track, threshold: 0.6 });
          slides.forEach(function (s) { self._io.observe(s); });
        }

        // Estado inicial das setas: `marcar` sai cedo no slide 0, entao o prev nasce desabilitado aqui.
        sincronizarSetas();

        function andar(passo) {
          var alvo = atual + passo;
          if (alvo < 0 || alvo >= slides.length) return;
          irPara(slides[alvo]);
          marcar(alvo);
        }
        if (prev) prev.addEventListener('click', function () { andar(-1); });
        if (next) next.addEventListener('click', function () { andar(1); });

        // Oferta da Base: com 1 unidade, o tom escolhido leva a galeria ao packshot dele. Com 2+
        // unidades o swatch mexe so na unidade, e a galeria fica. Evento vindo de outro alvo e ignorado.
        function deveSeguirTom(evento) {
          var alvo = evento.target;
          if (!alvo || alvo.tagName !== 'PDP-OFFER') return false;
          var marcado = alvo.querySelector('input[name="pdp-tier"]:checked');
          var card = marcado && marcado.closest('.pdp-offer__tier');
          if (card && card.dataset.quantidade === '1') return true;
          var sel = evento.detail && evento.detail.selected;
          return !!(sel && sel.direct !== undefined && Number(sel.qty) === 1);
        }
        function seguirTom(evento) {
          if (!self.isConnected || !deveSeguirTom(evento)) return;
          var id = evento.detail && evento.detail.variantId;
          if (id === undefined || id === null) return;
          for (var k = 0; k < slides.length; k++) {
            var lista = (slides[k].getAttribute('data-trio-gallery-variant') || '').split(',');
            if (lista.indexOf(String(id)) !== -1) {
              irPara(slides[k]);
              marcar(k);
              return;
            }
          }
        }
        document.addEventListener('pdp-offer:variant-changed', seguirTom);
        document.addEventListener('pdp-offer:swatch-clicked', seguirTom);

        // Teclado: o trilho e focavel e as setas andam um slide, papel que as bolinhas
        // cumpriam antes.
        if (track) {
          track.addEventListener('keydown', function (event) {
            // So com o foco no PROPRIO trilho (revisao da T8, N4): seta vinda da miniatura ou do
            // play rolava o carrossel e deixava o foco num botao fora da tela. Nao basta ignorar:
            // o navegador tambem rola o trilho sozinho (rolagem nativa de container com seta),
            // medido 326px com o foco na miniatura. Entao, vinda de um botao dentro do trilho, a
            // seta e anulada: o carrossel fica parado e o foco continua visivel.
            if (event.target !== track) {
              if ((event.key === 'ArrowRight' || event.key === 'ArrowLeft') && event.target.closest('button')) event.preventDefault();
              return;
            }
            var passo = 0;
            if (event.key === 'ArrowRight') passo = 1;
            else if (event.key === 'ArrowLeft') passo = -1;
            else return;
            var alvo = atual + passo;
            if (alvo < 0 || alvo >= slides.length) return;
            event.preventDefault();
            irPara(slides[alvo]);
            // Marca na hora, sem esperar o IntersectionObserver: durante a rolagem suave dois
            // toques seguidos na seta liam o MESMO `atual` e andavam um slide so.
            marcar(alvo);
          });
        }

        // Play do slide do video OU atalho do canto do slide 1 (fix round 6): os dois abrem o
        // MESMO lightbox, direto. O atalho nunca rola o trilho ate o slide do video (rolagem
        // horizontal por codigo arrasta o #page-wrap do tema), e o foco volta a quem abriu.
        this.addEventListener('click', function (event) {
          var gatilho = event.target.closest('[data-trio-gallery-play], [data-trio-gallery-atalho]');
          if (gatilho) abrirLightbox(gatilho);
        });
      }
    });
  }

  function initEventos() {
    // Gatilho de quick-shop (Tarefa 3): a interceptacao do clique NAO mora
    // aqui. Fix round 1 da Tarefa 8: este arquivo carrega com `defer`, que so
    // executa depois que o documento INTEIRO (as ~11 sections da LP) termina
    // de ser parseado. O <a href> do gatilho e real e fica clicavel assim que
    // o proprio HTML dele e parseado, bem antes disso. Clicar nessa janela
    // navegava a pagina de verdade pro PDP do componente (comprovado: 16/16
    // reproducoes tinham Page.frameNavigated do FRAME DE TOPO pra URL exata
    // do gatilho, pagehide disparado no documento original e o token em
    // window apagado -- 64% de falha em 25 execucoes isoladas). A
    // interceptacao (preventDefault + dispatch de trio:drawer-open) agora
    // mora num <script> INLINE, sem defer, no topo de
    // sections/biobio-trio-hero.liquid, que executa em milissegundos, antes
    // de o parser sequer alcancar o kit/os capitulos. Repetir o listener
    // aqui duplicaria o dispatch de trio:drawer-open por clique. Tarefa 9: o
    // mesmo vale pro gatilho "Nao sabe seu tom?" do heroi (link real pra
    // /pages/encontre-seu-tom, mesmo risco de navegacao cedo demais); o botao
    // equivalente DENTRO do quick-shop da Base nao precisa dessa guarda (so
    // existe apos assets/biobio-trio.js ja ter carregado), mas usa o MESMO
    // atributo de proposito e cai na mesma delegacao inline.

    // Rodada final da v2.1 (F4, m1 da revisao da Tarefa 13): estado do resumo do carrinho do tema NO
    // clique, lido em captura no document, antes do toggle do tema (delegado no document, fase de bolha)
    // trocar a classe. Com o resumo ja aberto, o "Ver carrinho" e o toggle que o fecha (como o icone do
    // cabecalho), e o recuo nao pode reabrir: antes, Enter no CTA com o resumo aberto fechava pelo toggle
    // e o recuo reabria com GET /search, o painel piscando uns 540 ms.
    var resumoAbertoNoClique = false;
    document.addEventListener('click', function (event) {
      var cta = event.target && event.target.closest ? event.target.closest('[data-trio-bar-cta], [data-trio-open-bundle]') : null;
      if (cta) resumoAbertoNoClique = document.body.classList.contains('show-cart-summary');
    }, true);

    // Barra fixa: SEMPRE abre o drawer, com selecao incompleta ou completa.
    document.addEventListener('click', function (event) {
      // Tarefa 8: qualquer elemento com data-trio-open-bundle (botao do heroi no desktop)
      // e a mesma acao da barra.
      var cta = event.target.closest('[data-trio-bar-cta], [data-trio-open-bundle]');
      if (!cta) return;
      event.preventDefault();
      // Tarefa 13 (item 1): depois do add, o mesmo botao abre o carrinho do tema. Quem abre e o toggle do
      // tema, no mesmo toque (C4, ver abrirCarrinhoDoTema); aqui so o recuo, depois do despacho, porque a
      // ordem entre este listener e o do tema no document nao e garantida. Sem recuo quando o resumo ja
      // estava aberto no clique (F4, ver resumoAbertoNoClique): o toggle do tema fechou de proposito.
      if (cta.hasAttribute('data-trio-ver-carrinho')) {
        if (!resumoAbertoNoClique) setTimeout(abrirCarrinhoDoTema, 0);
        return;
      }
      document.dispatchEvent(
        new CustomEvent('trio:drawer-open', {
          bubbles: true,
          detail: { mode: 'bundle', trigger: cta },
        })
      );
    });

    // Botao Voltar (Tarefa 9): desempilha a view anterior, se houver.
    // Escondido via [hidden] quando a pilha esta vazia (updateBackButton).
    document.addEventListener('click', function (event) {
      if (!event.target.closest('[data-trio-drawer-back]')) return;
      event.preventDefault();
      goBack();
    });

    // "Escolher meus tons" da janela do produto sem compra avulsa (Tarefa 13, item 5): leva ao seletor
    // do trio no mesmo drawer. E navegacao de dentro do drawer, entao a janela entra na pilha local,
    // como no "Nao sabe seu tom?" (Tarefa 9): o Voltar devolve o produto que a cliente estava vendo. O
    // botao so existe depois de o fragmento ser injetado por este arquivo, sem janela de clique morto.
    // Rodada final da v2.1 (F2, decisao do Breno de 27/09): o tom que a cliente escolheu na janela vai
    // junto (levarTomDaJanela), depois de o seletor entrar no drawer.
    document.addEventListener('click', function (event) {
      var botao = event.target.closest('[data-trio-qs-escolher]');
      if (!botao) return;
      event.preventDefault();
      var janela = botao.closest('[data-trio-qs-content]');
      if (openMode && openMode !== 'bundle') viewStack.push({ mode: openMode, cfg: currentCfg });
      openDrawer('bundle', { cfg: MODES.bundle });
      levarTomDaJanela(janela);
    });

    // F2: marca a janela em que a cliente escolheu um tom (troca de tom, ou toque no tom que ja estava
    // marcado). A janela abre com a variante inicial pre-marcada pelo snippet, que ela nao escolheu:
    // sem esta marca, "Escolher meus tons" nao leva nada. A marca mora no fragmento injetado, que e
    // trocado a cada produto aberto, entao nao passa de uma janela para outra.
    function marcarTomEscolhido(event) {
      var input = event.target && event.target.closest ? event.target.closest('[data-trio-qs-swatch-input]') : null;
      if (!input || input.disabled) return;
      var janela = input.closest('[data-trio-qs-content]');
      if (janela) janela.setAttribute('data-trio-qs-tom-escolhido', '');
    }
    document.addEventListener('change', marcarTomEscolhido);
    document.addEventListener('click', marcarTomEscolhido);

    // Tarefa 18: busca da janela no pointerdown/touchstart do gatilho, antes do click (preBuscarNoToque).
    // O que chegar primeiro comeca a busca; o outro acha a entrada no cache e nao pede de novo.
    document.addEventListener('pointerdown', preBuscarNoToque, { passive: true });
    document.addEventListener('touchstart', preBuscarNoToque, { passive: true });

    // Consumidor unico do evento.
    document.addEventListener('trio:drawer-open', function (event) {
      var detail = event.detail || {};
      if (detail.mode === 'bundle') {
        openDrawer('bundle', { trigger: detail.trigger });
      } else if (detail.mode === 'quickshop') {
        openQuickShop(detail);
      } else if (detail.mode === 'finder') {
        openFinder(detail);
      }
    });

    // Aplicacao explicita do finder (Tarefa 9): reage SOMENTE a
    // tone-finder:applied, o evento novo e opt-in que so dispara no clique
    // da cliente em "Usar este tom" (assets/biobio-tone-finder.js).
    // tone-finder:resolved (automatico, dispara a cada calculo) continua sem
    // nenhum listener aqui -- aplicar sem pedido seria pior que nao aplicar.
    document.addEventListener('tone-finder:applied', function (event) {
      var detail = event.detail || {};
      var id = String(detail.variantId || '');
      if (!id) return;

      // PDP v2 da Base (Task 4): sem <bundle-selector>, o tom vai para o <pdp-offer> da pagina. Com ele,
      // segue tudo abaixo, como sempre.
      if (!document.querySelector('bundle-selector')) {
        aplicarTomNaOferta(id, detail);
        return;
      }

      // O selector e SEMPRE o mesmo no unico (Tarefa 7: nunca clonado, so
      // movido por portal), entao um querySelector simples basta -- ache-o
      // onde estiver (host inline ou dentro da view bundle do drawer).
      var selector = document.querySelector('bundle-selector');
      var label = selector
        ? selector.querySelector('label.swatch[data-variant-id="' + cssEscape(id) + '"]')
        : null;

      // Swatch desabilitado (tom esgotado no fail-open do seletor) conta como ausente (fix round da
      // revisao da T11.1): o clique no label marcava o radio desabilitado e o status dizia "Tom
      // aplicado". Com o finder restrito ao kit isto nao chega aqui; a guarda segura o dado estranho.
      var inputDoLabel = label ? label.querySelector('input') : null;
      if (!label || label.classList.contains('swatch--disabled') || (inputDoLabel && inputDoLabel.disabled)) {
        // Erro recuperavel: NAO fecha o drawer nem troca de view, pra a
        // cliente poder tentar outro resultado ou usar Voltar/Fechar.
        setStatus('Não foi possível aplicar esse tom automaticamente. Escolha o tom na etapa de compra.');
        return;
      }

      // Clique no LABEL (nao no input): mesmo caminho de um clique real da
      // cliente (handleSwatchActivate em assets/biobio-bundle-selector.js) --
      // pinta o swatch, atualiza o pill e resolve a variante do combo. Sem
      // espelho, sem segundo estado.
      label.click();

      var tom = (detail.variant && detail.variant.titulo) || '';
      openDrawer('bundle', { cfg: MODES.bundle });
      setStatus(tom ? 'Tom aplicado: ' + tom + '.' : 'Tom aplicado.');
      // Mais especifico que o foco no painel que openDrawer ja deu: leva
      // direto pro proximo grupo pendente (ex.: cor do BBS), sem procurar.
      focusNextIncompleteGroup(selector);
    });

    // Finder do drawer (Tarefa 11.1): faixa sem nenhum tom no kit mostra a mensagem de
    // indisponivel (ver restringirFinderAoKit). Bubble no document: roda depois do handler do finder.
    document.addEventListener('click', function (event) {
      var faixa = event.target.closest('[data-trio-faixa-sem-tom]');
      if (!faixa) return;
      var finder = faixa.closest(FINDER_DO_DRAWER);
      if (finder) mostrarFaixaSemTom(finder);
    });

    // Quick-shop: troca de tom/cor dentro do fragmento injetado. Delegado (nao
    // registrado por instancia) porque a `view` da casca e reaproveitada entre
    // aberturas: um listener por instancia acumularia handler a cada produto.
    document.addEventListener('change', function (event) {
      var input = event.target.closest('[data-trio-qs-swatch-input]');
      if (!input) return;
      var root = input.closest('[data-trio-qs-content]');
      if (!root) return;
      var byId = parseQsVariants(root);
      applyQsVariant(root, byId[Number(input.value)]);
    });

    // Quick-shop: Home/End no radiogroup de tom/cor. Setas e roving tabindex ja
    // sao nativos do radio (mesmo grupo `name`); so Home/End precisa de JS.
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Home' && event.key !== 'End') return;
      var input = event.target;
      if (!input || input.getAttribute('type') !== 'radio') return;
      var group = input.closest('[data-trio-qs-swatches]');
      if (!group) return;
      var radios = Array.prototype.slice.call(group.querySelectorAll('input:not([disabled])'));
      if (!radios.length) return;
      event.preventDefault();
      var alvo = event.key === 'Home' ? radios[0] : radios[radios.length - 1];
      alvo.focus();
      alvo.checked = true;
      alvo.dispatchEvent(new Event('change', { bubbles: true }));
    });

    // Quick-shop: miniaturas da galeria trocam a imagem principal manualmente
    // (independente da troca de tom, que tambem escreve a mesma imagem).
    document.addEventListener('click', function (event) {
      var thumb = event.target.closest('[data-trio-qs-thumb]');
      if (!thumb) return;
      var root = thumb.closest('[data-trio-qs-content]');
      if (!root) return;
      var mediaImg = root.querySelector('[data-trio-qs-media]');
      root.querySelectorAll('[data-trio-qs-thumb]').forEach(function (t) {
        var ativo = t === thumb;
        t.classList.toggle('trio-qs__thumb--active', ativo);
        t.setAttribute('aria-pressed', String(ativo));
      });
      // srcset antes do src, pelo mesmo motivo de applyQsVariant (Tarefa 11.1).
      if (mediaImg) {
        mediaImg.srcset = thumb.dataset.srcset || '';
        mediaImg.src = thumb.dataset.src;
        if (thumb.dataset.alt) mediaImg.alt = thumb.dataset.alt;
      }
    });

    // Quick-shop: add-to-cart do componente avulso. Sempre {items:[...]} mesmo
    // com 1 item, guard de cartType, anti duplo-clique por classe. Estado final
    // do CTA SEMPRE derivado da variante selecionada agora (nunca reabilitado
    // as cegas no "finally": um swatch pode ter ficado indisponivel entre o
    // clique e a resposta).
    document.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-trio-qs-add]');
      if (!btn) return;
      event.preventDefault();
      if (btn.disabled || btn.classList.contains('trio-qs__add--adding')) return;

      var root = btn.closest('[data-trio-qs-content]');
      var variantId = Number(btn.dataset.variantId);
      if (!root || !variantId) return;

      var statusRow = root.querySelector('[data-trio-qs-add-status]');
      var addLabel = root.querySelector('[data-trio-qs-add-label]');

      btn.classList.add('trio-qs__add--adding');
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      if (statusRow) statusRow.textContent = '';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
      })
        .then(function (res) {
          if (res.ok) return res.json();
          return res
            .json()
            .catch(function () {
              return {};
            })
            .then(function (data) {
              throw new Error(data.description || 'HTTP ' + res.status);
            });
        })
        .then(function () {
          var t = window.theme;
          var cartPageMode = !!(t && t.settings && t.settings.cartType === 'page');
          if (t && typeof t.updateCartSummaries === 'function' && !cartPageMode) {
            try {
              t.updateCartSummaries(true, true, false);
            } catch (e) {
              console.warn('[trio] quick-shop updateCartSummaries falhou; indo pro /cart', e);
              window.location.href = '/cart';
            }
          } else {
            window.location.href = '/cart';
          }
        })
        .catch(function (err) {
          console.error('[trio] quick-shop add-to-cart falhou', err);
          if (statusRow) statusRow.textContent = 'Erro ao adicionar ao carrinho. Tente novamente.';
        })
        .then(function () {
          btn.classList.remove('trio-qs__add--adding');
          btn.removeAttribute('aria-busy');
          var byId = parseQsVariants(root);
          var selecionado = root.querySelector('[data-trio-qs-swatch-input]:checked');
          var v = selecionado ? byId[Number(selecionado.value)] : byId[variantId];
          var disponivel = v ? v.available : true;
          btn.disabled = !disponivel;
          if (addLabel && v) addLabel.textContent = disponivel ? 'Adicionar ao carrinho' : 'Esgotado';
        });
    });

    // Videos sob demanda (trilho e blocos): som exclusivo. Ativar o som de um
    // video muta todos os outros do contrato antes de desmutar o clicado (mesmo
    // padrao de assets/biobio-lp.js).
    document.addEventListener('click', function (event) {
      var soundButton = event.target.closest('[data-trio-sound]');
      if (!soundButton) return;
      var frame = soundButton.closest('[data-trio-video-frame]');
      var video = frame ? frame.querySelector(VIDEO_LAZY) : null;
      if (!video) return;

      if (video.muted) {
        document.querySelectorAll(VIDEO_LAZY).forEach(function (other) {
          if (other !== video) muteVideoTrilho(other);
        });
        carregarVideo(video);
        delete video.dataset.userPaused;
        video.muted = false;
        sincronizarSom(video);
        // O botao so pode AFIRMAR que o som ligou se o navegador deixar. No
        // WebKit, desmutar um video inline exige gesto do usuario na pilha de
        // chamada, e o replay da fila de cliques pendentes usa click() sintetico,
        // que nao concede ativacao. Engolindo a rejeicao (o .catch vazio de antes)
        // o botao dizia "som ligado" com o video mudo e possivelmente pausado, e
        // um probe que so lesse aria-pressed/is-on/muted daria sucesso. Voltar ao
        // estado mudo na rejeicao mantem botao, rotulo e video dizendo a mesma
        // coisa.
        var promessa = video.play();
        if (promessa && typeof promessa.catch === 'function') {
          promessa.catch(function () {
            muteVideoTrilho(video);
          });
        }
      } else {
        muteVideoTrilho(video);
      }
    });

    // Tela cheia (Tarefa 13, item 2; decisao do Breno de 25/09): o toque no video dos blocos e dos
    // cartoes cai no botao [data-trio-video-abrir] por cima dele e abre o lightbox da galeria com
    // aquele video, com som, do ponto em que estava. Substitui o toque que pausava e retomava o video
    // na propria pagina: pausar sem sair dela e o botao de play, ao lado. Vale tambem sob
    // prefers-reduced-motion (o lightbox abre parado, com os controles nativos). Um toque antes do boot
    // entra na fila inline do heroi como modal e e repetido aqui por click().
    document.addEventListener('click', function (event) {
      var abrir = event.target.closest('[data-trio-video-abrir]');
      if (!abrir) return;
      event.preventDefault();
      abrirLightbox(abrir);
    });

    // Blocos (Tarefa 9) e cartoes (Tarefa 11.1): botao "Assistir ao trecho", toggle de play e pausa
    // na propria pagina, alcancavel pelo teclado (o <video> sem controls nao recebe foco). Desde a
    // Tarefa 13 e o unico jeito de pausar sem abrir a tela cheia (WCAG 2.2.2).
    document.addEventListener('click', function (event) {
      var playButton = event.target.closest('[data-trio-play]');
      if (!playButton) return;
      var frame = playButton.closest('[data-trio-video-frame]');
      var video = frame ? frame.querySelector(VIDEO_LAZY) : null;
      if (video) alternarVideo(video);
    });

    // Trilho de videos: setas do desktop.
    document.addEventListener('click', function (event) {
      var arrow = event.target.closest('[data-trio-video-scroll]');
      if (!arrow) return;
      var carousel = arrow.closest('[data-trio-video-carousel]');
      var track = carousel ? carousel.querySelector('[data-trio-video-track]') : null;
      if (!track) return;
      var card = track.querySelector('.trio-videos__item');
      var step = card ? card.getBoundingClientRect().width + 12 : track.clientWidth * 0.8;
      var direction = arrow.dataset.trioVideoScroll === 'next' ? 1 : -1;
      track.scrollBy({ left: step * direction, behavior: reduceMotion() ? 'auto' : 'smooth' });
    });

    // Trilho de videos: chip que abre o drawer do trio (video sem componente
    // de origem: ramos 2/3 da cascata, ou par sem produto no ramo 1). E um
    // <a href="#comprar"> real e same-page -- sem JS o navegador rola ate o
    // bloco de compra sozinho, nunca navegacao de verdade pra outra pagina,
    // entao nao precisa da guarda inline sem defer que protege os gatilhos
    // de quick-shop/finder (esses SIM navegam de verdade antes do JS
    // interceptar, ver sections/biobio-trio-hero.liquid).
    document.addEventListener('click', function (event) {
      var chip = event.target.closest('[data-trio-video-bundle-chip]');
      if (!chip) return;
      if (chip.target === '_blank') return;
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      document.dispatchEvent(
        new CustomEvent('trio:drawer-open', {
          bubbles: true,
          detail: { mode: 'bundle', trigger: chip },
        })
      );
    });

    // Videos sob demanda: rede de seguranca de som exclusivo. `play` nao
    // borbulha, entao o listener precisa do terceiro argumento (capture)
    // pra pegar o evento de qualquer player, mesmo padrao de
    // assets/biobio-lp.js. De quebra, espelha o estado no botao de play.
    document.addEventListener(
      'play',
      function (event) {
        var video = event.target;
        if (!(video instanceof HTMLVideoElement)) return;
        if (!video.hasAttribute('data-trio-lazy-video')) return;
        sincronizarPlay(video);
        if (video.muted) return;
        document.querySelectorAll(VIDEO_LAZY).forEach(function (other) {
          if (other !== video && !other.muted) {
            other.pause();
            muteVideoTrilho(other);
          }
        });
      },
      true
    );

    // `pause` tambem nao borbulha. Dispara no fim do trecho (sem loop), no
    // IntersectionObserver e no botao: o play volta a mostrar "tocar".
    document.addEventListener(
      'pause',
      function (event) {
        var video = event.target;
        if (!(video instanceof HTMLVideoElement)) return;
        if (!video.hasAttribute('data-trio-lazy-video')) return;
        sincronizarPlay(video);
      },
      true
    );

    // Som exclusivo tambem quando o som liga FORA dos nossos botoes: controles
    // nativos (prefers-reduced-motion) ou o video do lightbox da galeria. Um video
    // qualquer que fica audivel muta os outros do contrato; o botao de som de
    // cada um acompanha o estado real.
    document.addEventListener(
      'volumechange',
      function (event) {
        var video = event.target;
        if (!(video instanceof HTMLVideoElement)) return;
        if (video.hasAttribute('data-trio-lazy-video')) sincronizarSom(video);
        if (video.muted || video.volume === 0) return;
        document.querySelectorAll(VIDEO_LAZY).forEach(function (other) {
          if (other !== video && !other.muted) muteVideoTrilho(other);
        });
      },
      true
    );

    // Theme Editor: section re-renderizada traz videos novos, ainda sem observer.
    document.addEventListener('shopify:section:load', function () {
      initVideoTrilho();
    });

    // Fechar: botao, backdrop e Escape.
    document.addEventListener('click', function (event) {
      if (!openMode) return;
      if (event.target.closest('[data-trio-drawer-close]') || event.target.closest('[data-trio-drawer-backdrop]')) {
        event.preventDefault();
        closeDrawer();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (!openMode || !panel) return;
      if (event.key === 'Escape' || event.keyCode === 27) {
        event.preventDefault();
        closeDrawer();
        return;
      }
      if (event.key !== 'Tab' && event.keyCode !== 9) return;

      var focaveis = Array.prototype.slice.call(panel.querySelectorAll(FOCUSABLE)).filter(function (el) {
        return el.offsetParent !== null || el === document.activeElement;
      });
      // Radio nativo tem roving tabindex: dos N swatches de um MESMO grupo (name),
      // so UM entra na sequencia real de Tab (o marcado, ou o primeiro do grupo se
      // nenhum estiver marcado) -- os outros o navegador pula sozinho, sem qualquer
      // tabindex="-1" no HTML pra este seletor enxergar. Sem este filtro, primeiro/
      // ultimo eram calculados sobre TODOS os radios (6 tons + 5 cores no trio), e
      // nunca batiam com o activeElement real depois que a cliente entrava num
      // grupo via Tab: o boundary abaixo nunca disparava e o foco escapava pro
      // <body> ao tentar avançar do ultimo grupo (achado 13, medido por
      // focoNaoVaza).
      var gruposRadio = {};
      focaveis.forEach(function (el) {
        if (el.tagName !== 'INPUT' || el.type !== 'radio' || !el.name) return;
        var g = gruposRadio[el.name];
        if (!g) { g = { first: el, checked: null }; gruposRadio[el.name] = g; }
        if (el.checked) g.checked = el;
      });
      focaveis = focaveis.filter(function (el) {
        if (el.tagName !== 'INPUT' || el.type !== 'radio' || !el.name) return true;
        var g = gruposRadio[el.name];
        return el === (g.checked || g.first);
      });
      if (!focaveis.length) return;
      var primeiro = focaveis[0];
      var ultimo = focaveis[focaveis.length - 1];

      // Foco no proprio painel (tabindex=-1, estado logo apos abrir) ou fora
      // dele: Tab vai pro primeiro, Shift+Tab pro ultimo. Antes, com o foco no
      // painel, o navegador seguia a ordem do DOM e saia pro <body>.
      if (document.activeElement === panel || !panel.contains(document.activeElement)) {
        event.preventDefault();
        (event.shiftKey ? ultimo : primeiro).focus();
        return;
      }
      if (event.shiftKey && document.activeElement === primeiro) {
        event.preventDefault();
        ultimo.focus();
      } else if (!event.shiftKey && document.activeElement === ultimo) {
        event.preventDefault();
        primeiro.focus();
      }
    });

    // Defesa extra do trap, igual a do bottom-sheet do kit: se o foco cair fora
    // por qualquer via, traz de volta. Inerte com o drawer fechado.
    document.addEventListener('focusin', function (event) {
      if (!openMode || !panel || panel.contains(event.target)) return;
      panel.focus();
    });

    // Foco que sai do painel sem destino (relatedTarget null = foi pro body):
    // volta pro painel. Inerte com o drawer fechado.
    document.addEventListener('focusout', function (event) {
      if (!openMode || !panel) return;
      if (event.relatedTarget === null || !panel.contains(event.relatedTarget)) {
        setTimeout(function () { if (openMode && panel && !panel.contains(document.activeElement)) panel.focus(); }, 0);
      }
    });

    // Espelho do seletor.
    document.addEventListener('bundle:variant-changed', function (event) {
      sincronizar(event.target);
    });

    // Id da variante no envio do form do seletor (C8, ver observarAdd). Em captura: roda antes do
    // handler do tema no form e do recuo de page template no document.
    document.addEventListener('submit', registrarEnvio, true);

    // O carrinho do tema (body.show-cart-summary, z-index 9999999) abre POR CIMA
    // do nosso dialogo depois do add. Manter o nosso aberto deixaria o carrinho
    // inert (o inert e aplicado nos irmaos do drawer) e o cliente sem conseguir
    // interagir com ele. Entao fechamos, sem devolver o foco: quem assume a tela
    // agora e o carrinho.
    //
    // O mesmo observador (fix round 1 da T13, C3) confere o carrinho quando o resumo sai da tela: se a
    // cliente tirou o trio la dentro, a barra deixa de dizer "Ver carrinho". E tambem quando o tema termina
    // uma atualizacao do carrinho com o resumo ja fechado (a classe updating-cart sai do body, 500 ms
    // depois de o pedido voltar): o "Remover" do carrinho lateral so manda o /cart/change.js 700 ms depois
    // do toque, e quem fecha o resumo antes disso le um carrinho que ainda tem o trio (medido no check
    // barraVoltaSemOTrioNoCarrinho, caso b).
    if (window.MutationObserver && document.body) {
      var resumoAberto = document.body.classList.contains('show-cart-summary');
      var carrinhoAtualizando = document.body.classList.contains('updating-cart');
      new MutationObserver(function () {
        var aberto = document.body.classList.contains('show-cart-summary');
        var atualizando = document.body.classList.contains('updating-cart');
        if (openMode && aberto) {
          closeDrawer({ restoreFocus: false });
        }
        if ((resumoAberto && !aberto) || (carrinhoAtualizando && !atualizando && !aberto)) conferirVarianteNoCarrinho();
        resumoAberto = aberto;
        carrinhoAtualizando = atualizando;
      }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    }

    // Volta pelo bfcache (depois do checkout, por exemplo): o estado da pagina e o de antes de sair, e o
    // carrinho pode ter mudado (C3).
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) conferirVarianteNoCarrinho();
    });
  }

  /* ================================================================ */
  /* Fila de cliques pendentes (Tarefa 11): flush ao ficar pronto        */
  /* ================================================================ */

  // Contraparte de sections/biobio-trio-hero.liquid (script inline, sem
  // defer, no topo do heroi): enquanto este arquivo nao rodava, um clique
  // no gatilho de quick-shop/finder ou nos controles do trilho (som, setas)
  // era prevenido de navegar mas o evento se perdia no vazio -- medido nesta
  // tarefa, 0/20 de sucesso a ~130ms do gatilho aparecer. A guarda inline
  // agora enfileira {tipo, trigger, detail} em window.__biobioTrioQueue em
  // vez de descartar. Aqui, DEPOIS de initEventos() ja ter registrado os
  // listeners de trio:drawer-open e dos controles do trilho, replay cada
  // item: reabrir o MESMO evento (gatilho de quick-shop/finder) ou um
  // trigger.click() sintetico (som/setas/toque do trilho, que o delegado de
  // initEventos() ja escuta) -- o clique original acaba completando a acao
  // de verdade, so um pouco depois, em vez de morrer. Marca
  // window.__biobioTrioReady = true ANTES do replay, pra as novas guardas
  // inline virarem no-op e nao reenfileirar o que este loop acabou de
  // despachar.
  //
  // O toque de modal (no maximo um: o slot modal do heroi) e repetido POR ULTIMO (fix round da
  // revisao da T11.1). Abrir o modal silencia os videos; na ordem dos toques, "modal, depois som"
  // abria o modal e so entao ligava o som do bloco, audivel atras dele. Os demais seguem na ordem.
  function flushFilaPendente() {
    window.__biobioTrioReady = true;
    var fila = window.__biobioTrioQueue || [];
    window.__biobioTrioQueue = [];
    var modais = fila.filter(function (item) { return item.modal; });
    fila = fila.filter(function (item) { return !item.modal; }).concat(modais);
    fila.forEach(function (item) {
      if (item.trigger) item.trigger.classList.remove('is-trio-pending');
      if (item.tipo === 'evento') {
        item.trigger.dispatchEvent(new CustomEvent('trio:drawer-open', { bubbles: true, detail: item.detail }));
      } else if (item.tipo === 'clique') {
        item.trigger.click();
      }
    });
  }

  // BOOT EM DUAS ETAPAS.
  //
  // 1. AGORA, na execucao do script: registra a delegacao de eventos no document
  //    e tenta portar drawer e barra. Nao espera o DOMContentLoaded, porque esta
  //    LP tem dezenas de <script defer> e o DOMContentLoaded chega mais de um
  //    segundo depois deste arquivo executar (medido localmente; em 4G e pior).
  //    Nesse intervalo a barra ja estaria pintada, e um toque nela nao faria nada
  //    (a cliente conclui que o site travou). Como a delegacao vive no document e
  //    as refs sao resolvidas sob demanda (garantirDrawer/garantirBarra), o clique
  //    funciona a partir do instante em que este arquivo roda.
  // 2. No DOMContentLoaded (ou ja, se o documento estiver pronto): repete o
  //    garantir* para o caso de o markup ainda nao existir na etapa 1, e faz o
  //    primeiro espelho do seletor na barra. O seletor resolve a variante sozinho
  //    no proprio connectedCallback (JSON inline, sem rede) e NAO emite evento
  //    nessa primeira resolucao, por isso o sincronizar explicito aqui.
  //
  // initVideoTrilho() entra na MESMA etapa 1 (Tarefa 10): o markup do trilho e
  // HTML estatico da propria section, ja presente no DOM na primeira linha
  // que este arquivo executa (defer garante parse completo antes disso), sem
  // precisar do DOMContentLoaded.
  //
  // ORDEM DO FLUSH. flushFilaPendente() roda depois de initEventos() porque os
  // replays precisam encontrar os listeners ja registrados, e depois de
  // garantirDrawer()/garantirBarra()/initVideoTrilho() porque precisa encontrar o
  // DOM que eles montam. A versao anterior chamava o flush logo apos initEventos,
  // e a barra entrava no <body> DEPOIS de applyInert() tirar o retrato: medido,
  // barInert=false no caminho do replay e true no caminho normal, ou seja, a barra
  // escapava do inert naquela abertura e continuava exposta pra tecnologia
  // assistiva mesmo com o drawer aberto por cima. Nao reordenar sem medir isso de
  // novo.
  initEventos();
  garantirDrawer();
  garantirBarra();
  initVideoTrilho();
  // Antes do flush (um toque enfileirado no "Descobrir meu tom" abre o finder ja restrito) e antes de
  // o biobio-tone-finder.js (defer, depois deste no heroi) iniciar e pintar os pontos das faixas.
  restringirFinderAoKit();
  // Antes do flush: um add nao sai de toque enfileirado, mas o observador do botao tem de existir
  // antes de qualquer caminho de compra (Tarefa 13, item 1).
  observarAdd();
  flushFilaPendente();
  // Tarefa 18: so agenda (a pre-busca da janela sai depois do load). Depois do flush: um toque enfileirado
  // num gatilho ja abriu a janela e pos o produto no cache, e a pre-busca pula esse.
  agendarPreBuscaJanelas();

  function bootTardio() {
    garantirDrawer();
    garantirBarra();
    sincronizar(null);
    initVideoTrilho();
    restringirFinderAoKit();
    observarAdd();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootTardio, { once: true });
  } else {
    bootTardio();
  }

  // Gancho de teste (Task 4 da PDP v2 da Base): so existe com window.__biobioTrioTestHook === true, que
  // nenhuma pagina da loja define (tests/pdp-v2/trio-oferta-js.test.mjs, em node:vm).
  if (window.__biobioTrioTestHook === true) window.__biobioTrioTest = { swatchesDeTom: swatchesDeTom };
})();
